const events = [
    /*{id:"13615",
    author: "Alessandro",
      title: 'NEU: "Osterhasen" Workshop für Kinder/Erwachsene in der Stadtwerkstatt',
      start: new Date(2024, 2, 9, 14, 0),
      end: new Date(2024, 2, 9, 15, 30),
      allDay: false,
      resource: { id: 1, details: '"Hasen" Workshop für Erwachsene' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop-Allessondro2.jpg',
      hexColor:'#247b6aff',
      description:`
      Ergebnis: Kleiner Osterhase (12×12cm) 
      Empfehlung: für Kinder ab ca. 8 Jahren 


      Deine Workshop-Vorteile:
      
      1. Du brauchst nichts mitbringen. Alle Materialien und Werkzeuge sind vorhanden. Ebenso wie kleine belegte Baguettes und Getränke 🧃
      2. In der Gruppe macht es viel mehr Spaß. Gönn dir einfach einen gemütlichen Nachmittag unter Gleichgesinnten.
      3. Du bekommst alles ganz genau erklärt und erhältst sofort Antworten auf alle deine Fragen.
      4. Du kannst dein Werk selbstverständlich sofort mit nach Hause nehmen.`,
      price: '18,00',
      restAmount:10,
    },*/
    /*{ id:"13613",
      author: "Alessandro",
      title: 'NEU: "Herzen" Workshop für Kinder/Erwachsene in der Stadtwerkstatt ',
      start: new Date(2024, 3, 20, 13, 30),
      end: new Date(2024, 3, 20, 15, 0),
      allDay: false,
      resource: { id: 2, details: 'NEU: ,, Herzen " Workshop für Kinder/Erwachsene in der Stadtwerkstatt ' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +"/Workshop/Workshop_Alessandro.jpeg",
      hexColor:'#247b6aff',
      description:`
Dauer: ca. 1 - 1½h
Ergebnis: Herz (12×12cm)
Für Kinder ab ca. 8 Jahren geeignet.

Deine Workshop-Vorteile:

1. Du brauchst nichts mitbringen. Alle Materialien und Werkzeuge sind vorhanden. Ebenso wie kleine Snacks und Getränke.
2. In der Gruppe macht es viel mehr Spaß. Gönn dir einfach einen gemütlichen Nachmittag unter Gleichgesinnten.
3. Du bekommst alles ganz genau erklärt und erhältst sofort Antworten auf alle deine Fragen.
4. Du kannst dein Werk selbstverständlich sofort mit nach Hause nehmen.`,
      price: '15,00',
      restAmount:12,
    },*/
    {id:"1",
      author: "Kati",
      title: 'Weihnachtlicher Nachmittag mit Ei-der-Daus 🎄🎁',
      start: new Date(2024, 11, 1, 17, 0),
      end: new Date(2024, 11, 1, 19, 0),
      allDay: false,
      resource: { id: 2, details: 'Weihnachtlicher Nachmittag mit Ei-der-Daus 🎄🎁' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/weihnachten-eiderdaus.jpeg',
      hexColor:'#8f2d56',
      description:`
     Gestaltet Euer eigenes Ei in festlichem Glanz und verschönert es mit weihnachtlichen Bändern, funkelnden Anhängern und individuellen Designs – perfekt für die besinnliche Jahreszeit! ✨🎅

Neben kreativer Inspiration erwartet Euch eine gemütliche Atmosphäre mit leckeren Snacks, Kaffee, Tee und warmem Punsch, um Euch die winterliche Stimmung ins Herz zu zaubern.

Ein zauberhafter Nachmittag oder Abend für Freundinnen, Teams, Vereine und alle, die die Freude an kreativem Kunsthandwerk teilen – und das alles im festlichen Weihnachtszauber. 🌟

Ihr möchtet diese Veranstaltung zu einem individuellen Termin für Eure Gruppe buchen? Kontaktiert mich und wir machen Euren persönlichen Weihnachts-Workshop wahr! 🎄
      `,
      price: '40,00',
      restAmount:0,
    },     {id:"116852e3241",
      author: "Kati",
      title: 'Armband-Workshop',
      start: new Date(2026, 4, 30, 14, 0),
      end: new Date(2026, 4, 30, 15, 30),
      allDay: false,
      resource: { id: 2, details: 'Armband-Workshop' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/katiarmband.jpeg',
      hexColor:'#8f2d56',
      description:`
     Lust auf kreatives Gestalten? Dann melde dich zu unserem Armband-Workshop an!


In diesem Workshop hast du die Möglichkeit, 2 verschiedene Armbänder deiner Wahl zu fertigen und diese mit deinen persönlichen Lieblingscharms zu verschönern. Lass deiner Fantasie freien Lauf und kreiere Schmuckstücke, die deine Persönlichkeit widerspiegeln!


Ablauf:


- Dauer: 1,5 Stunden
- Preis pro Person: 35,-€


Im Preis enthalten sind:


- Mineralwasser und Kaffee
- Etwas zum Naschen
- Alle benötigten Materialien, die du für die Armbänder brauchst


Als besonderes Geschenk erhältst du ein *praktisches Schmucksäckchen* zur Aufbewahrung deiner neuen Kreationen!


Sei dabei und sichere dir deinen Platz!


Wir freuen uns auf dich! `,
      price: '35,00',
      restAmount:12,
    },
     {id:"11653241",
      author: "Kati",
      title: 'Armband-Workshop',
      start: new Date(2026, 6, 23, 10, 0),
      end: new Date(2026, 6, 23, 12, 0),
      allDay: false,
      resource: { id: 2, details: 'Armband-Workshop' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/katiwh.jpeg',
      hexColor:'#8f2d56',
      description:`
     Liebe Kinder,



habt ihr Lust auf einen kreativen Sommertag voller Farben, Spaß und Fantasie?



Dann kommt zu unserem Lichthäuser-Workshop in der StadtWERKSTATT!



Gemeinsam gestalten wir vier kleine Lichthäuser in euren Lieblingsfarben und verzieren sie mit bunten Bändern und Perlen – jedes wird zu einem echten Unikat!

Wir freuen uns auf euch und eure kreativen Ideen! 💛✨
      `,
      price: '25,00',
      restAmount:12,
    },
    {id:"116573241",
      author: "Kati",
      title: 'Armband-Workshop',
      start: new Date(2026, 6, 30, 10, 0),
      end: new Date(2026, 6, 30, 12, 0),
      allDay: false,
      resource: { id: 2, details: 'Armband-Workshop' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/katiwh.jpeg',
      hexColor:'#8f2d56',
      description:`
     Liebe Kinder,



habt ihr Lust auf einen kreativen Sommertag voller Farben, Spaß und Fantasie?



Dann kommt zu unserem Lichthäuser-Workshop in der StadtWERKSTATT!



Gemeinsam gestalten wir vier kleine Lichthäuser in euren Lieblingsfarben und verzieren sie mit bunten Bändern und Perlen – jedes wird zu einem echten Unikat!

Wir freuen uns auf euch und eure kreativen Ideen! 💛✨
      `,
      price: '25,00',
      restAmount:12,
    },
     {id:"116s541",
      author: "Kati",
      title: 'Armband-Workshop',
      start: '',
             end: '',
      allDay: false,
      resource: { id: 2, details: 'Armband-Workshop' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/katiarmband.jpeg',
      hexColor:'#8f2d56',
      description:`
     Lust auf kreatives Gestalten? Dann melde dich zu unserem Armband-Workshop an!


In diesem Workshop hast du die Möglichkeit, 2 verschiedene Armbänder deiner Wahl zu fertigen und diese mit deinen persönlichen Lieblingscharms zu verschönern. Lass deiner Fantasie freien Lauf und kreiere Schmuckstücke, die deine Persönlichkeit widerspiegeln!


Ablauf:


- Dauer: 1,5 Stunden
- Preis pro Person: 35,-€


Im Preis enthalten sind:


- Mineralwasser und Kaffee
- Etwas zum Naschen
- Alle benötigten Materialien, die du für die Armbänder brauchst


Als besonderes Geschenk erhältst du ein *praktisches Schmucksäckchen* zur Aufbewahrung deiner neuen Kreationen!


Sei dabei und sichere dir deinen Platz!


Wir freuen uns auf dich! `,
      price: '35,00',
      restAmount:12,
    },
    {id:"2",
      author: "Kati",
      title: 'Weihnachtsfeier mit Ei-der-Daus 🎄🎁',
      start: new Date(2024, 11, 5, 17, 0),
      end: new Date(2024, 11, 5, 19, 0),
      allDay: false,
      resource: { id: 2, details: 'Weihnachtsfeier mit Ei-der-Daus 🎄🎁' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/weihnachten-eiderdaus.jpeg',
      hexColor:'#8f2d56',
      description:`
     Gestaltet Euer eigenes Ei in festlichem Glanz und verschönert es mit weihnachtlichen Bändern, funkelnden Anhängern und individuellen Designs – perfekt für die besinnliche Jahreszeit! ✨🎅

Neben kreativer Inspiration erwartet Euch eine gemütliche Atmosphäre mit leckeren Snacks, Kaffee, Tee und warmem Punsch, um Euch die winterliche Stimmung ins Herz zu zaubern.

Ein zauberhafter Nachmittag oder Abend für Freundinnen, Teams, Vereine und alle, die die Freude an kreativem Kunsthandwerk teilen – und das alles im festlichen Weihnachtszauber. 🌟

Ihr möchtet diese Veranstaltung zu einem individuellen Termin für Eure Gruppe buchen? Kontaktiert mich und wir machen Euren persönlichen Weihnachts-Workshop wahr! 🎄
      `,
      price: '40,00',
      restAmount:0,
    },
    {id:"13614",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2026, 1, 22, 14, 0),
      end: new Date(2026, 1, 22, 16, 30),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '49,00',
      restAmount:12,
    },

    {id:"1828214",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2025, 2, 14, 17, 0),
      end: new Date(2025, 2, 14, 19, 0),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '40,00',
      restAmount:12,
    },
    {id:"13611114",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2025, 2, 30, 13, 0),
      end: new Date(2025, 2, 30, 15, 0),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '40,00',
      restAmount:9,
    },
    {id:"136141112",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2025, 3, 5, 14, 0),
      end: new Date(2025, 3, 5, 16, 0),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '40,00',
      restAmount:12,
    },
    {id:"1361411251",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2025, 3, 12, 14, 0),
      end: new Date(2025, 3, 12, 16, 0),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '40,00',
      restAmount:8,
    },
    {id:"13614112511",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: '',
             end: '',
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '49,00',
      restAmount:12,
    },
    {id:"13614112512",
      author: "Kati",
      title: 'Ei-der-Daus: Gestaltet Euer persönliches Ei',
      start: new Date(2026, 2, 6, 16, 0),
      end: new Date(2026, 2, 6, 18, 0),
      allDay: false,
      resource: { id: 2, details: 'Ei-der-Daus: Gestaltet Euer persönliches Ei' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
      hexColor:'#8f2d56',
      description:`
      Gestaltet Euer eigenes Ei unter meiner Anleitung und verschönert es mit Bändern und individuellen Anhängern. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
      
      Ein schöner Nachmittag oder Abend für Freundinnen, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.


      Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich!
      `,
      price: '49,00',
      restAmount:0,
    },
    {id:"136141111",
      author: "Anett",
      title: 'Workshop "Frühlingskränze" "Osterdeko"',
      start: new Date(2026, 2, 20, 16, 0),
      end: new Date(2026, 2, 20, 18, 0),
      allDay: false,
      resource: { id: 2, details: 'Workshop "Frühlingskränze" "Osterdeko"' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopkati.jpeg',
      hexColor:'#8f2d56',
      description:`
      DIESER KURS BIETET DIR:


Freue Dich auf eine inspirierende Zeit mit vielen kreativen Möglichkeiten. In unserem Workshop erwarten Dich:


Einführung und Beratung zur Anfertigung Deines Kranzes


Große Auswahl an Trockenblumen, frischen Zweigen und Oster-Dekoration


Unterstützung bei der Gestaltung Deines Kranzes


Alle Materialien, die Du brauchst


Sweets, Drinks und eine entspannte Zeit


WAS DU MIT NACH HAUSE NIMMST:


Deinen tollen Kranz



Kosten 45€
Ca. 2 Std.
      
      `,
      price: '45,00',
      restAmount:6,
    },
    {
    id:"13617",
    author: "Thomas",
      title: 'Malerei mit Kohle - Entdecke die Motive der Altstadt in Bautzen',
      start: new Date(2025, 7, 16, 10, 0),
      end: new Date(2025, 7, 16, 12, 30),
      allDay: false,
      resource: { id: 1, details: 'Malerei mit Kohle - Entdecke die Motive der Altstadt in Bautzen' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Workshop3.jpeg',
      hexColor:'#FBB13C',
      description:`
      Liebe Kunstinteressierte,


wir freuen uns, Sie zu unserem kommenden Workshop mit Thomas Liebig einzuladen! Tauchen Sie ein in die faszinierende Welt der Kohlezeichnung und erkunden Sie die inspirierenden Motive der historischen Altstadt von Bautzen.


In diesem Workshop lernen Sie die Grundlagen der Kohlezeichnung und erhalten hilfreiche Tipps und Techniken von Thomas Liebig, einem erfahrenen Künstler. Egal, ob Sie Anfänger oder Fortgeschrittener sind, dieser Workshop bietet die perfekte Gelegenheit, Ihre Fähigkeiten zu vertiefen und die Schönheit der Bautzener Altstadt festzuhalen.


Wir freuen uns auf Ihre Teilnahme und darauf, gemeinsam kreativ zu sein!`,
      price: '40,00',
      restAmount:12,
    }, {
    id:"113617",
    author: "Thomas",
      title: 'Malerei mit Kohle - Entdecke die Motive der Altstadt in Bautzen',
      start: new Date(2025, 8, 20, 14, 0),
      end: new Date(2025, 8, 20, 16, 30),
      allDay: false,
      resource: { id: 1, details: 'Malerei mit Kohle - Entdecke die Motive der Altstadt in Bautzen' },
      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Workshop1.jpeg',
      hexColor:'#FBB13C',
      description:`
      Liebe Kunstinteressierte,

      
wir freuen uns, Sie zu unserem kommenden Workshop mit Thomas Liebig einzuladen! Tauchen Sie ein in die faszinierende Welt der Kohlezeichnung und erkunden Sie die inspirierenden Motive der historischen Altstadt von Bautzen.


In diesem Workshop lernen Sie die Grundlagen der Kohlezeichnung und erhalten hilfreiche Tipps und Techniken von Thomas Liebig, einem erfahrenen Künstler. Egal, ob Sie Anfänger oder Fortgeschrittener sind, dieser Workshop bietet die perfekte Gelegenheit, Ihre Fähigkeiten zu vertiefen und die Schönheit der Bautzener Altstadt festzuhalen.


Wir freuen uns auf Ihre Teilnahme und darauf, gemeinsam kreativ zu sein!`,
      price: '40,00',
      restAmount:12,
    }, 
    
    {
      id:"136181",
      author: "Thomas",
      title: 'Aquarell-Erlebnis: Ihr Foto als Kunst',
        start: new Date(2024, 8, 14, 14, 0),
        end: new Date(2024, 8, 14, 16, 0),
        allDay: false,
        resource: { id: 1, details: 'Aquarell-Erlebnis: Ihr Foto als Kunst' },
        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Eule.jpeg',
        hexColor:'#FBB13C',
        description:`
        Gestaltet Euer eigenes Aquarell unter meiner Anleitung von einem Foto Eurer Wahl. Ich zeige euch einige Tricks wie man ein Aquarell aufbaut und besondere Effekte erzielen kann. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.

Ein schöner Nachmittag oder Abend für Freunde, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.
 

Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich.`,
        price: '39,00',
        restAmount:12,
      },
      /*{
        id:"136182",
        author: "Thomas",
        title: 'Aquarell-Erlebnis: Ihr Foto als Kunst',
          start: new Date(2024, 9, 25, 18, 0),
          end: new Date(2024, 9, 25, 20, 0),
          allDay: false,
          resource: { id: 1, details: 'Aquarell-Erlebnis: Ihr Foto als Kunst' },
          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Eule.jpeg',
          hexColor:'#FBB13C',
          description:`
          Gestaltet Euer eigenes Aquarell unter meiner Anleitung von einem Foto Eurer Wahl. Ich zeige euch einige Tricks wie man ein Aquarell aufbaut und besondere Effekte erzielen kann. Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
  
  Ein schöner Nachmittag oder Abend für Freunde, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.
   
  
  Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich.`,
          price: '39,00',
          restAmount:12,
        },*/
        {
          id:"136183",
          author: "Thomas",
          title: 'Malkurs: Weihnachtskarten gestalten – Eine kleine Freude für Kinder und Erwachsene',
            start: new Date(2025, 11, 13, 12, 0),
            end: new Date(2025, 11, 13, 14, 0),
            allDay: false,
            resource: { id: 1, details: 'Malkurs: Weihnachtskarten gestalten – Eine kleine Freude für Kinder und Erwachsene' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Workshop-Thomas.jpeg',
            hexColor:'#FBB13C',
            description:`
    Lassen Sie sich von der festlichen Jahreszeit inspirieren und gestalten Sie Ihre eigenen, persönlichen Weihnachtskarten – für Ihre Liebsten oder als kreative Ausdrucksform für sich selbst! In diesem Kurs haben sowohl Kinder als auch Erwachsene die Möglichkeit, weihnachtliche Karten zu malen oder zu kleben. Ob mit Aquarellfarben, Acryl oder Collagetechniken – hier ist Ihrer Kreativität keine Grenze gesetzt.



Was Sie erwartet:



Für Kinder und Erwachsene: Alle sind willkommen! Es gibt einfache Anleitungen für die Kleinen und anspruchsvollere Techniken für Erwachsene.


Materialien: Alle benötigten Materialien wie Farben, Pinsel, Kleber und Papier werden gestellt.


Techniken: Wir experimentieren mit Malen und Basteln, von einfachen Wasserfarbenbildern bis hin zu Collagen aus Papier.


Persönliche Gestaltung: Erstellen Sie individuelle Weihnachtskarten für Freunde und Familie. Ob süße Rentier-Motive, Schneelandschaften oder weihnachtliche Muster – Sie entscheiden, wie Ihre Karten aussehen!


Gemeinsames Werkeln: Genießen Sie eine kreative Auszeit in netter Atmosphäre und lassen Sie sich von der Gruppe inspirieren.





Anmeldung: Um die Teilnehmerzahl zu planen, melden Sie sich bitte bis spätestens 10. Dezember an.
Teilnahmegebühr: 15,00 Euro 
Alter: Für alle Altersgruppen geeignet!


Egal, ob Sie zum ersten Mal mit Pinsel und Papier arbeiten oder schon ein erfahrener Bastler sind – der Kurs ist für jeden eine kleine Auszeit vom Alltag und eine kreative Gelegenheit, Weihnachtskarten für die Familie, Freunde oder Kollegen zu gestalten.


Wir freuen uns auf einen entspannten und kreativen Nachmittag!
    `,
            price: '15,00',
            restAmount:12,
          },
          {
            id:"136184",
            author: "Thomas",
            title: 'Aquarell-Erlebnis für Kinder: Kartengestaltung',
              start: new Date(2024, 11, 14, 14, 0),
              end: new Date(2024, 11, 14, 16, 0),
              allDay: false,
              resource: { id: 1, details: 'Aquarell-Erlebnis für Kinder: Kartengestaltung' },
              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Thomas_Liebig/Thomas_Liebig_Karte.jpeg',
              hexColor:'#FBB13C',
              description:`
              Entdecken Sie die Kunst des Aquarells in einem gemütlichen, inspirierenden Workshop. Unter meiner Anleitung verwandeln Sie ein mitgebrachtes Foto in ein lebendiges Aquarellbild. Dieser Kurs ist perfekt für Einsteiger und Fortgeschrittene geeignet und bietet eine kurze Einführung in die Aquarelltechniken sowie individuelle Tipps, um Ihre Fertigkeiten zu verbessern.
      
      Neben der praktischen Arbeit erwartet Sie eine entspannte Atmosphäre mit Snacks und Getränken, die das kreative Erlebnis abrunden. Bringen Sie einfach Ihr Lieblingsfoto mit, und ich zeige Ihnen, wie Sie es in ein persönliches Kunstwerk umsetzen können. Freuen Sie sich auf ein paar Stunden voller Kreativität und Entspannung.`,
              price: '39,00',
              restAmount:12,
            },
            {
              id:"136185",
              author: "Thomas",
              title: 'Kohle-Skizzieren in der Stadt',
                start: new Date(2024, 7, 28, 18, 0),
                end: new Date(2024, 7, 28, 20, 0),
                allDay: false,
                resource: { id: 1, details: 'Kohle-Skizzieren in der Stadt' },
                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Kohlebild.jpeg',
                hexColor:'#FBB13C',
                description:`
               Kommt mit mir durch Bautzen und lasst uns ein Kunstwerk in Skizzenformat mit Kohle malen. Bei schönem Wetter durchlaufen wir die Altstadt und fertigen kleine Kunstwerke an.
 
Ein schöner Tag oder Abend für Freunde, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.
 

Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich.`,
                price: '25,00',
                restAmount:12,
              },
              {
                id:"136186",
                author: "Thomas",
                title: 'Kohle-Skizzieren in der Stadt',
                  start: new Date(2024, 10, 9, 10, 0),
                  end: new Date(2024, 10, 9, 12, 0),
                  allDay: false,
                  resource: { id: 1, details: 'Kohle-Skizzieren in der Stadt' },
                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Kohlebild-Workshop.jpeg',
                  hexColor:'#FBB13C',
                  description:`
                 Kommt mit mir durch Bautzen und lasst uns ein Kunstwerk in Skizzenformat mit Kohle malen. Bei schönem Wetter durchlaufen wir die Altstadt und fertigen kleine Kunstwerke an.
 
Ein schöner Tag oder Abend für Freunde, Teams, Vereine und natürlich alle, die dieses Kunsthandwerk begeistert.
 

Ihr möchtet diese Veranstaltung mit individuellem Termin für eure Gruppe buchen - dann kontaktiert mich.`,
                  price: '25,00',
                  restAmount:12,
                },
      
      /*{
        id:"13655",
        author: "Carina",
        title: 'Nähkurs für Anfänger',
          start: new Date(2024, 3, 6, 12, 0),
          end: new Date(2024, 3, 6, 14, 0),
          allDay: false,
          resource: { id: 1, details: 'Nähkurs für Anfänger' },
          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/naehkurs.jpeg',
          hexColor:'#Ffa500',
          description:`
Du nähst an Deiner eigenen Nähmaschine unter meiner 
Anleitung eine Kissenhülle Deiner Wahl.
Als Material stelle ich Dir vorgefertigte Quadrate aus BioJacquard in 
verschiedenen Farben und Mustern zur Verfügung.
Du lernst in diesem Kurs Nähgrundlagen, die Dir in Alltag helfen, um 
Kleidung oder Deko zu ändern, zu reparieren oder einfach Projekte selbst 
herzustellen.
Wenn Du hast, bringe Deine Nähmaschine mit Garn und eine Stretchnadel 
mit. Alle weiteren Nähutensilien und Getränke sind inklusive.
Ich freue mich auf Dich! Carina ☀️`,
          price: '40,00',
          restAmount:8,
        },*/
        /*{
          id:"13415",
          author: "Carina",
          title: 'Nähkurs für Anfänger',
            start: new Date(2024, 4, 25, 12, 0),
            end: new Date(2024, 4, 25, 14, 0),
            allDay: false,
            resource: { id: 1, details: 'Nähkurs für Anfänger' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/naehkurs.jpeg',
            hexColor:'#Ffa500',
            description:`
  Du nähst an Deiner eigenen Nähmaschine unter meiner 
  Anleitung eine Kissenhülle Deiner Wahl.
  Als Material stelle ich Dir vorgefertigte Quadrate aus BioJacquard in 
  verschiedenen Farben und Mustern zur Verfügung.
  Du lernst in diesem Kurs Nähgrundlagen, die Dir in Alltag helfen, um 
  Kleidung oder Deko zu ändern, zu reparieren oder einfach Projekte selbst 
  herzustellen.
  Wenn Du hast, bringe Deine Nähmaschine mit Garn und eine Stretchnadel 
  mit. Alle weiteren Nähutensilien und Getränke sind inklusive.
  Ich freue mich auf Dich! Carina ☀️`,
            price: '40,00',
            restAmount:8,
          },*/
           /* {
          id:"188415",
          author: "Steffi",
          title: 'Töpfer dein persönliches Unikat',
            start: new Date(2024, 7, 2, 18, 0),
            end: new Date(2024, 7, 2, 20, 30),
            allDay: false,
            resource: { id: 1, details: 'Töpfer dein persönliches Unikat' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/toepferkurs.jpeg',
            hexColor:'#Ffa500',
            description:`
            Kreiert Eure eigenen wundervollen Einzelstücke. Wir verwenden Ton für den Hochbrand, somit sind Eure Kunstwerke frostsicher und spülmaschinenfest.
            Wir modellieren gemeinsam Tassen, Schalen, Becher etc....
            Diese brenne & glasiere ich dann nach Euren Vorstellungen. Eine Auswahl an Glasurmustern wird im Workshop ausliegen.
            Wer selber glasieren möchte, kann dazu gern einen anderen Termin mit mir vereinbaren. 
            Abholbereit werden Eure Werke dann ca. 10 Tage später sein. Abholung ist dann in der StadtWERKSTATT 😉
            Ich freue mich auf Euch!

            `,
            price: '39,00',
            restAmount:8,
          },
          {
            id:"187415",
            author: "Steffi",
            title: 'Töpfer dein persönliches Unikat',
              start: new Date(2024, 8, 6, 18, 0),
              end: new Date(2024, 8, 6, 20, 30),
              allDay: false,
              resource: { id: 1, details: 'Töpfer dein persönliches Unikat' },
              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/toepferkurs.jpeg',
              hexColor:'#Ffa500',
              description:`
              Kreiert Eure eigenen wundervollen Einzelstücke. Wir verwenden Ton für den Hochbrand, somit sind Eure Kunstwerke frostsicher und spülmaschinenfest.
              Wir modellieren gemeinsam Tassen, Schalen, Becher etc....
              Diese brenne & glasiere ich dann nach Euren Vorstellungen. Eine Auswahl an Glasurmustern wird im Workshop ausliegen.
              Wer selber glasieren möchte, kann dazu gern einen anderen Termin mit mir vereinbaren. 
              Abholbereit werden Eure Werke dann ca. 10 Tage später sein. Abholung ist dann in der StadtWERKSTATT 😉
              Ich freue mich auf Euch!
  
              `,
              price: '39,00',
              restAmount:8,
            },
            {
              id:"186415",
              author: "Steffi",
              title: 'Töpfer dein persönliches Unikat',
                start: new Date(2024, 9, 4, 18, 0),
                end: new Date(2024, 9, 4, 20, 30),
                allDay: false,
                resource: { id: 1, details: 'Töpfer dein persönliches Unikat' },
                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/toepferkurs.jpeg',
                hexColor:'#Ffa500',
                description:`
                Kreiert Eure eigenen wundervollen Einzelstücke. Wir verwenden Ton für den Hochbrand, somit sind Eure Kunstwerke frostsicher und spülmaschinenfest.
                Wir modellieren gemeinsam Tassen, Schalen, Becher etc....
                Diese brenne & glasiere ich dann nach Euren Vorstellungen. Eine Auswahl an Glasurmustern wird im Workshop ausliegen.
                Wer selber glasieren möchte, kann dazu gern einen anderen Termin mit mir vereinbaren. 
                Abholbereit werden Eure Werke dann ca. 10 Tage später sein. Abholung ist dann in der StadtWERKSTATT 😉
                Ich freue mich auf Euch!
    
                `,
                price: '39,00',
                restAmount:8,
              },
              {
                id:"185415",
                author: "Steffi",
                title: 'Töpfer dein persönliches Unikat',
                  start: new Date(2024, 10, 1, 18, 0),
                  end: new Date(2024, 10, 1, 20, 30),
                  allDay: false,
                  resource: { id: 1, details: 'Töpfer dein persönliches Unikat' },
                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/toepferkurs.jpeg',
                  hexColor:'#Ffa500',
                  description:`
                  Kreiert Eure eigenen wundervollen Einzelstücke. Wir verwenden Ton für den Hochbrand, somit sind Eure Kunstwerke frostsicher und spülmaschinenfest.
                  Wir modellieren gemeinsam Tassen, Schalen, Becher etc....
                  Diese brenne & glasiere ich dann nach Euren Vorstellungen. Eine Auswahl an Glasurmustern wird im Workshop ausliegen.
                  Wer selber glasieren möchte, kann dazu gern einen anderen Termin mit mir vereinbaren. 
                  Abholbereit werden Eure Werke dann ca. 10 Tage später sein. Abholung ist dann in der StadtWERKSTATT 😉
                  Ich freue mich auf Euch!
      
                  `,
                  price: '39,00',
                  restAmount:8,
                },
                {
                  id:"184415",
                  author: "Steffi",
                  title: 'Töpfer dein persönliches Unikat',
                    start: new Date(2024, 11, 6, 18, 0),
                    end: new Date(2024, 11, 6, 20, 30),
                    allDay: false,
                    resource: { id: 1, details: 'Töpfer dein persönliches Unikat' },
                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/toepferkurs.jpeg',
                    hexColor:'#Ffa500',
                    description:`
                    Kreiert Eure eigenen wundervollen Einzelstücke. Wir verwenden Ton für den Hochbrand, somit sind Eure Kunstwerke frostsicher und spülmaschinenfest.
                    Wir modellieren gemeinsam Tassen, Schalen, Becher etc....
                    Diese brenne & glasiere ich dann nach Euren Vorstellungen. Eine Auswahl an Glasurmustern wird im Workshop ausliegen.
                    Wer selber glasieren möchte, kann dazu gern einen anderen Termin mit mir vereinbaren. 
                    Abholbereit werden Eure Werke dann ca. 10 Tage später sein. Abholung ist dann in der StadtWERKSTATT 😉
                    Ich freue mich auf Euch!
        
                    `,
                    price: '39,00',
                    restAmount:8,
                  },*/
                  {
                    id:"184415518",
                    author: "Sarah",
                    title: 'Verschicke Deine eigene Karte - Kartengestaltung',
                      start: new Date(2025, 0, 27, 18, 0),
                      end: new Date(2025, 0, 27, 20, 0),
                      allDay: false,
                      resource: { id: 1, details: 'Verschicke Deine eigene Karte - Kartengestaltung' },
                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-karten.jpeg',
                      hexColor:'#Ffa500',
                      description:`
                      Dieses Jahr möchtest Du Deinen Lieben mit einer selbst gestalteten Karte eine Freude
bereiten?
Sogar einen vergrößerten Abzug deiner Karte kannst Du als Bild verschenken.
Wie das geht, erlernst Du bei mir im Kurs.
Wir arbeiten mit Aquarellfarben in Kombination mit Zeichnung.
Bring zum Kurs ein Lieblingsmotiv oder Lieblingsfoto mit und wir verarbeiten es kreativ zum
Motiv auf Deiner Karte oder Deinem Print. Es stehen auch Ideen zur Motivwahl und zu
unterschiedlichen Themen bereit.
Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive
          
                      `,
                      price: '40,00',
                      restAmount:12,
                    },
                    {
                      id:"1844117",
                      author: "Sarah",
                      title: 'Deine Geschichte in Bildern - Erzählsteine Bemalen',
                        start: new Date(2024, 9, 30, 18, 0),
                        end: new Date(2024, 9, 30, 20, 0),
                        allDay: false,
                        resource: { id: 1, details: 'Deine Geschichte in Bildern - Erzählsteine Bemalen' },
                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-steine.jpeg',
                        hexColor:'#Ffa500',
                        description:`
                        In diesem Kurs stellen wir Erzählsteine her. Diese können in der Sprachförderung und im
Sprachenlernen eingesetzt werden.
Im Kurs erhältst Du Steine, die Du mit Motiven bemalst.
Es stehen verschiedene Ideen zu Motiven und Themen bereit, aber Du kannst auch sehr
gern eine Geschichte mitbringen, zu der Du Deine eigenen Erzählsteine herstellst.
Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
            
                        `,
                        price: '40,00',
                        restAmount:12,
                      },
                      {
                        id:"184415515",
                        author: "Sarah",
                        title: 'Verschicke Deine eigene Karte - Kartengestaltung',
                          start: new Date(2025, 1, 12, 18, 0),
                          end: new Date(2025, 1, 12, 20, 0),
                          allDay: false,
                          resource: { id: 1, details: 'Verschicke Deine eigene Karte - Kartengestaltung' },
                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-karten.jpeg',
                          hexColor:'#Ffa500',
                          description:`
                          Dieses Jahr möchtest Du Deinen Lieben mit einer selbst gestalteten Karte eine Freude
    bereiten?
    Sogar einen vergrößerten Abzug deiner Karte kannst Du als Bild verschenken.
    Wie das geht, erlernst Du bei mir im Kurs.
    Wir arbeiten mit Aquarellfarben in Kombination mit Zeichnung.
    Bring zum Kurs ein Lieblingsmotiv oder Lieblingsfoto mit und wir verarbeiten es kreativ zum
    Motiv auf Deiner Karte oder Deinem Print. Es stehen auch Ideen zur Motivwahl und zu
    unterschiedlichen Themen bereit.
    Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive
              
                          `,
                          price: '40,00',
                          restAmount:12,
                        },
                        {
                          id:"184415514",
                          author: "Sarah",
                          title: 'Deine Geschichte in Bildern - Erzählsteine Bemalen',
                            start: new Date(2024, 10, 13, 17, 0),
                            end: new Date(2024, 10, 13, 19,0),
                            allDay: false,
                            resource: { id: 1, details: 'Deine Geschichte in Bildern - Erzählsteine Bemalen' },
                            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-steine.jpeg',
                            hexColor:'#Ffa500',
                            description:`
                            In diesem Kurs stellen wir Erzählsteine her. Diese können in der Sprachförderung und im
    Sprachenlernen eingesetzt werden.
    Im Kurs erhältst Du Steine, die Du mit Motiven bemalst.
    Es stehen verschiedene Ideen zu Motiven und Themen bereit, aber Du kannst auch sehr
    gern eine Geschichte mitbringen, zu der Du Deine eigenen Erzählsteine herstellst.
    Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
                
                            `,
                            price: '40,00',
                            restAmount:12,
                          },
                          {
                            id:"1844155122",
                            author: "Sarah",
                            title: 'Verschicke Deine eigene Karte - Kartengestaltung',
                            start: new Date(2025, 1, 26, 18, 0),
                            end: new Date(2025, 1, 26, 20,0),
                              allDay: false,
                              resource: { id: 1, details: 'Verschicke Deine eigene Karte - Kartengestaltung' },
                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-karten.jpeg',
                              hexColor:'#Ffa500',
                              description:`
                              Dieses Jahr möchtest Du Deinen Lieben mit einer selbst gestalteten Karte eine Freude
        bereiten?
        Sogar einen vergrößerten Abzug deiner Karte kannst Du als Bild verschenken.
        Wie das geht, erlernst Du bei mir im Kurs.
        Wir arbeiten mit Aquarellfarben in Kombination mit Zeichnung.
        Bring zum Kurs ein Lieblingsmotiv oder Lieblingsfoto mit und wir verarbeiten es kreativ zum
        Motiv auf Deiner Karte oder Deinem Print. Es stehen auch Ideen zur Motivwahl und zu
        unterschiedlichen Themen bereit.
        Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive
                  
                              `,
                              price: '40,00',
                              restAmount:12,
                            },
                            {
                              id:"184415511",
                              author: "Sarah",
                              title: 'Deine Geschichte in Bildern - Erzählsteine Bemalen',
                                start: new Date(2024, 11, 16, 18, 0),
                                end: new Date(2024, 11, 16, 20,0),
                                allDay: false,
                                resource: { id: 1, details: 'Deine Geschichte in Bildern - Erzählsteine Bemalen' },
                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-steine.jpeg',
                                hexColor:'#Ffa500',
                                description:`
                                In diesem Kurs stellen wir Erzählsteine her. Diese können in der Sprachförderung und im
        Sprachenlernen eingesetzt werden.
        Im Kurs erhältst Du Steine, die Du mit Motiven bemalst.
        Es stehen verschiedene Ideen zu Motiven und Themen bereit, aber Du kannst auch sehr
        gern eine Geschichte mitbringen, zu der Du Deine eigenen Erzählsteine herstellst.
        Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive.
                    
                                `,
                                price: '40,00',
                                restAmount:12,
                              },
                              {
                                id:"184415533",
                                author: "Sarah",
                                title: 'Verschicke Deine eigene Karte - Kartengestaltung',
                                start: new Date(2025, 2, 19, 18, 0),
                                end: new Date(2025, 2, 19, 20,0),
                                  allDay: false,
                                  resource: { id: 1, details: 'Verschicke Deine eigene Karte - Kartengestaltung' },
                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-karten.jpeg',
                                  hexColor:'#Ffa500',
                                  description:`
                                  Dieses Jahr möchtest Du Deinen Lieben mit einer selbst gestalteten Karte eine Freude
            bereiten?
            Sogar einen vergrößerten Abzug deiner Karte kannst Du als Bild verschenken.
            Wie das geht, erlernst Du bei mir im Kurs.
            Wir arbeiten mit Aquarellfarben in Kombination mit Zeichnung.
            Bring zum Kurs ein Lieblingsmotiv oder Lieblingsfoto mit und wir verarbeiten es kreativ zum
            Motiv auf Deiner Karte oder Deinem Print. Es stehen auch Ideen zur Motivwahl und zu
            unterschiedlichen Themen bereit.
            Zum Workshop sind ein paar kleine Snacks, Kaffee, Tee und Mineralwasser inklusive
                      
                                  `,
                                  price: '40,00',
                                  restAmount:12,
                                },
                               
                                  {
                                    id:"184415522339",
                                    author: "Corinna",
                                    title: 'Naturkosmetik einfach selber machen',
                                      start: new Date(2026, 0, 22, 18, 0),
                                      end: new Date(2026, 0, 22, 20,0),
                                      allDay: false,
                                      resource: { id: 1, details: 'Naturkosmetik einfach selber machen' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-kosmetik.jpeg',
                                      hexColor:'#00CED1',
                                      description:`
                                       Naturkosmetik wird für immer mehr
   Menschen die Alternative zur Kosmetik
   aus der Drogerie. 
  Du lernst verschieden
   Salbengrundlagen und deren
   Wirkungsweisen kennen. Mit
   aromatischen Kräutern aus dem
   eigenen Garten und duftenden Ölen
   stellen wir natürlich pflegende
   Kosmetik her. Aus den Ansatzölen
   werden Creme und Körperbutter, Deo
   und Zahncreme kreieren wir mit
   altbekannten Hausmitteln. 
  

   Mein Name ist
   Corinna Fischer
   seit fast 30 Jahren ist natürliche
   Gesundheit mein Arbeits- und
   Lebensinhalt. Als ausgebildete
   medizinische Kosmetikerin bin ich mit
   der Herstellung von Kosmetika
   vertraut, meine physiotherapeutische
   Ausbildung vertieft diese Anwendungen
   zur ganzheitlichen Gesunderhaltung.
                          
                                      `,
                                      price: '98,00',
                                      restAmount:12,
                                    },
                                    {
                                      id:"18441552266",
                                      author: "Corinna",
                                      title: 'Naturkosmetik einfach selber machen',
                                        start: new Date(2026, 7, 20, 18, 0),
                                        end: new Date(2026, 7, 20, 20,0),
                                        allDay: false,
                                        resource: { id: 1, details: 'Naturkosmetik einfach selber machen' },
                                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-kosmetik.jpeg',
                                        hexColor:'#00CED1',
                                        description:`
                                         Naturkosmetik wird für immer mehr
     Menschen die Alternative zur Kosmetik
     aus der Drogerie. 
    Du lernst verschieden
     Salbengrundlagen und deren
     Wirkungsweisen kennen. Mit
     aromatischen Kräutern aus dem
     eigenen Garten und duftenden Ölen
     stellen wir natürlich pflegende
     Kosmetik her. Aus den Ansatzölen
     werden Creme und Körperbutter, Deo
     und Zahncreme kreieren wir mit
     altbekannten Hausmitteln. 
    
     
     Mein Name ist
     Corinna Fischer
     seit fast 30 Jahren ist natürliche
     Gesundheit mein Arbeits- und
     Lebensinhalt. Als ausgebildete
     medizinische Kosmetikerin bin ich mit
     der Herstellung von Kosmetika
     vertraut, meine physiotherapeutische
     Ausbildung vertieft diese Anwendungen
     zur ganzheitlichen Gesunderhaltung.
                            
                                        `,
                                        price: '98,00',
                                        restAmount:12,
                                      },
                                      {
                                        id:"184415522662",
                                        author: "Corinna",
                                        title: 'Heilsalben & Tinkturen',
                                          start: new Date(2026, 1, 26, 18, 0),
                                          end: new Date(2026, 1, 26, 20,0),
                                          allDay: false,
                                          resource: { id: 1, details: 'Heilsalben & Tinkturen' },
                                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                          hexColor:'#00CED1',
                                          description:`
                                           Wertvolle Heilkräuter in einer
 kraftvollen Heilsalbe und wirksame
 Tinkturen wie Oxymel sind ein
 Geschenk der Natur. Diese selbst
 herzustellen verbindet uns wieder mit
 uns selbst und schenkt uns
 Gesundheit und Wohlergehen.
 

 
 Inhalt dieser DenkWerkstatt:
 - Heilsalbe gegen Schmerzen
 - Natürliches Antibiotikum
 - Stärkende Tinktur
 - Heilsalbe bei Hautproblemen
 - NACHTKERZENSALBE
 - HAGEBUTTENOXYMEL
 - ARNIKASALBE
 - SCHWEDENKRÄUTER


 Die besondere Wirkung dieser
 Heilsalben und Tinkuteren
 werden bei der Anwendung
 sichtbar. Natürliche Zutaten,
 schönende Herstellung und die
 persönliche Hingabe gestalten
 außergewöhnliche Heilschätze.
                              
                                          `,
                                          price: '98,00',
                                          restAmount:12,
                                        },
                                        {
                                          id:"184415522661",
                                          author: "Corinna",
                                          title: 'Naturkosmetik einfach selber machen',
                                            start: new Date(2025, 2, 20, 18, 0),
                                            end: new Date(2025, 2, 20, 20,0),
                                            allDay: false,
                                            resource: { id: 1, details: 'Naturkosmetik einfach selber machen' },
                                            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-kosmetik.jpeg',
                                            hexColor:'#00CED1',
                                            description:`
                                             Naturkosmetik wird für immer mehr
         Menschen die Alternative zur Kosmetik
         aus der Drogerie. 
        Du lernst verschieden
         Salbengrundlagen und deren
         Wirkungsweisen kennen. Mit
         aromatischen Kräutern aus dem
         eigenen Garten und duftenden Ölen
         stellen wir natürlich pflegende
         Kosmetik her. Aus den Ansatzölen
         werden Creme und Körperbutter, Deo
         und Zahncreme kreieren wir mit
         altbekannten Hausmitteln. 
        
         
         Mein Name ist
         Corinna Fischer
         seit fast 30 Jahren ist natürliche
         Gesundheit mein Arbeits- und
         Lebensinhalt. Als ausgebildete
         medizinische Kosmetikerin bin ich mit
         der Herstellung von Kosmetika
         vertraut, meine physiotherapeutische
         Ausbildung vertieft diese Anwendungen
         zur ganzheitlichen Gesunderhaltung.
                                
                                            `,
                                            price: '98,00',
                                            restAmount:12,
                                          },
                                          {
                                            id:"1844155226621",
                                            author: "Corinna",
                                            title: 'Heilsalben mit DMSO',
                                              start: new Date(2026, 8, 24, 18, 0),
                                              end: new Date(2026, 8, 24, 20,0),
                                              allDay: false,
                                              resource: { id: 1, details: 'Heilsalben & Tinkturen' },
                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                              hexColor:'#00CED1',
                                              description:`
                                               Wertvolle Heilkräuter in einer
     kraftvollen Heilsalbe und wirksame
     Tinkturen wie Oxymel sind ein
     Geschenk der Natur. Diese selbst
     herzustellen verbindet uns wieder mit
     uns selbst und schenkt uns
     Gesundheit und Wohlergehen.
     
    
     
     Inhalt dieser DenkWerkstatt:
     - Heilsalbe gegen Schmerzen
     - Natürliches Antibiotikum
     - Stärkende Tinktur
     - Heilsalbe bei Hautproblemen
     - NACHTKERZENSALBE
     - HAGEBUTTENOXYMEL
     - ARNIKASALBE
     - SCHWEDENKRÄUTER
    
    
     Die besondere Wirkung dieser
     Heilsalben und Tinkuteren
     werden bei der Anwendung
     sichtbar. Natürliche Zutaten,
     schönende Herstellung und die
     persönliche Hingabe gestalten
     außergewöhnliche Heilschätze.
                                  
                                              `,
                                              price: '98,00',
                                              restAmount:12,
                                            },
                                            /*{
                                              id:"1844155226622",
                                              author: "Corinna",
                                              title: 'Heilsalben & Tinkturen',
                                                start: new Date(2025, 7, 14, 18, 0),
                                                end: new Date(2025, 7, 14, 20,0),
                                                allDay: false,
                                                resource: { id: 1, details: 'Heilsalben & Tinkturen' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                                hexColor:'#00CED1',
                                                description:`
                                                 Wertvolle Heilkräuter in einer
       kraftvollen Heilsalbe und wirksame
       Tinkturen wie Oxymel sind ein
       Geschenk der Natur. Diese selbst
       herzustellen verbindet uns wieder mit
       uns selbst und schenkt uns
       Gesundheit und Wohlergehen.
       
      
       
       Inhalt dieser DenkWerkstatt:
       - Heilsalbe gegen Schmerzen
       - Natürliches Antibiotikum
       - Stärkende Tinktur
       - Heilsalbe bei Hautproblemen
       - NACHTKERZENSALBE
       - HAGEBUTTENOXYMEL
       - ARNIKASALBE
       - SCHWEDENKRÄUTER
      
      
       Die besondere Wirkung dieser
       Heilsalben und Tinkuteren
       werden bei der Anwendung
       sichtbar. Natürliche Zutaten,
       schönende Herstellung und die
       persönliche Hingabe gestalten
       außergewöhnliche Heilschätze.
                                    
                                                `,
                                                price: '98,00',
                                                restAmount:12,
                                              },*/
                                              {
                                                id:"1844155226623",
                                                author: "Corinna",
                                                title: 'Heilsalben & Tinkturen',
                                                  start: new Date(2025, 10, 13, 18, 0),
                                                  end: new Date(2025, 10, 13, 20,0),
                                                  allDay: false,
                                                  resource: { id: 1, details: 'Heilsalben & Tinkturen' },
                                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                                  hexColor:'#00CED1',
                                                  description:`
                                                   Wertvolle Heilkräuter in einer
         kraftvollen Heilsalbe und wirksame
         Tinkturen wie Oxymel sind ein
         Geschenk der Natur. Diese selbst
         herzustellen verbindet uns wieder mit
         uns selbst und schenkt uns
         Gesundheit und Wohlergehen.
         
        
         
         Inhalt dieser DenkWerkstatt:
         - Heilsalbe gegen Schmerzen
         - Natürliches Antibiotikum
         - Stärkende Tinktur
         - Heilsalbe bei Hautproblemen
         - NACHTKERZENSALBE
         - HAGEBUTTENOXYMEL
         - ARNIKASALBE
         - SCHWEDENKRÄUTER
        
        
         Die besondere Wirkung dieser
         Heilsalben und Tinkuteren
         werden bei der Anwendung
         sichtbar. Natürliche Zutaten,
         schönende Herstellung und die
         persönliche Hingabe gestalten
         außergewöhnliche Heilschätze.
                                      
                                                  `,
                                                  price: '98,00',
                                                  restAmount:12,
                                                },
                                                {
                                                  id:"1844155226624",
                                                  author: "Corinna",
                                                  title: 'Oxymel - Natürlicher Stoffwechsel',
                                                    start: new Date(2025, 4, 15, 18, 0),
                                                    end: new Date(2025, 4, 15, 20,0),
                                                    allDay: false,
                                                    resource: { id: 1, details: 'Oxymel - Natürlicher Stoffwechsel' },
                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Oxymel.png',
                                                    hexColor:'#00CED1',
                                                    description:`
                                                     Herstellung von Oxymel für eine natürlichen Stoffwechselförderung


                                                     Das fermentierte Naturprodukt Essig hat eine anregende Wirkung auf den Stoffwechsel und reguliert auf angenehme Weise viele körpereigene Prozesse. Ein wertvolles Antioxidans das für ein starkes Immunsystem sorgt und den Verdauungsapparat gesund hält.

                                        
                                                    `,
                                                    price: '98,00',
                                                    restAmount:12,
                                                  },
                                                  {
                                                    id:"1844155226625",
                                                    author: "Corinna",
                                                    title: 'Oxymel - Natürlicher Stoffwechsel',
                                                      start: new Date(2025, 8, 4, 18, 0),
                                                      end: new Date(2025, 8, 4, 20,0),
                                                      allDay: false,
                                                      resource: { id: 1, details: 'Oxymel - Natürlicher Stoffwechsel' },
                                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                                      hexColor:'#00CED1',
                                                      description:`
                                                       Herstellung von Oxymel für eine natürlichen Stoffwechselförderung
  
  
                                                       Das fermentierte Naturprodukt Essig hat eine anregende Wirkung auf den Stoffwechsel und reguliert auf angenehme Weise viele körpereigene Prozesse. Ein wertvolles Antioxidans das für ein starkes Immunsystem sorgt und den Verdauungsapparat gesund hält.
  
                                          
                                                      `,
                                                      price: '98,00',
                                                      restAmount:12,
                                                    },
                                                    {
                                                      id:"1844155226626",
                                                      author: "Corinna",
                                                      title: 'Oxymel - Natürlicher Stoffwechsel',
                                                        start: new Date(2025, 10, 27, 18, 0),
                                                        end: new Date(2025, 10, 27, 20,0),
                                                        allDay: false,
                                                        resource: { id: 1, details: 'Oxymel - Natürlicher Stoffwechsel' },
                                                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                                        hexColor:'#00CED1',
                                                        description:`
                                                         Herstellung von Oxymel für eine natürlichen Stoffwechselförderung
    
    
                                                         Das fermentierte Naturprodukt Essig hat eine anregende Wirkung auf den Stoffwechsel und reguliert auf angenehme Weise viele körpereigene Prozesse. Ein wertvolles Antioxidans das für ein starkes Immunsystem sorgt und den Verdauungsapparat gesund hält.
    
                                            
                                                        `,
                                                        price: '98,00',
                                                        restAmount:12,
                                                      },
                                                      {
                                                        id:"1844155226627",
                                                        author: "Corinna",
                                                        title: 'Traditionelle Europäische Medizin',
                                                          start: new Date(2025, 9, 17, 18, 0),
                                                          end: new Date(2025, 9, 17, 20,0),
                                                          allDay: false,
                                                          resource: { id: 1, details: 'Traditionelle Europäische Medizin' },
                                                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/heilkunde.jpeg',
                                                          hexColor:'#00CED1',
                                                          description:`
                                                           Kurs zur Traditionelle Europäische Medizin
                                              
                                                          `,
                                                          price: '98,00',
                                                          restAmount:12,
                                                        },
                                      {
                                        id:"18441552231139",
                                        author: "Kathrin",
                                        title: 'Keramikkurs Engel',
                                          start: new Date(2024, 10, 26, 16, 0),
                                          end: new Date(2024, 10, 26, 18,0),
                                          allDay: false,
                                          resource: { id: 1, details: 'Naturkosmetik einfach selber machen' },
                                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Engel.jpeg',
                                          hexColor:'#800080',
                                          description:`
                                          Fertige deinen eigenen kleinen Schutzengel für dich, für einen lieben Menschen oder als ganz persönliches Geschenk zu Weihnachten. Mit einigen Tricks kannst du deinem Engel aus Keramik Persönlichkeit und Charme einhauchen. Ich zeige dir wie ... 
Kaffee, Tee und Mineralwasser stehen  inklusive zur Verfügung.  Weiter Absprachen können gern getroffen werden.
                                          `,
                                          price: '35,00',
                                          restAmount:0,
                                        },
                                        {
                                          id:"19",
                                          author: "Kathrin",
                                          title: 'Keramikkurs Minischalen',
                                            start: new Date(2025, 1, 14, 16, 0),
                                            end: new Date(2025, 1, 14, 18,0),
                                            allDay: false,
                                            resource: { id: 1, details: 'Keramikkurs Minischalen' },
                                            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_Schalen.jpg',
                                            hexColor:'#800080',
                                            description:`
                                            Fertige kleine Minischalen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen cleanen oder einen verspielten Look kreieren, der ein kleines Schälchen zu einem zauberhaften Blickfang werden lässt. Ich zeige dir wie... 
Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weitere terminliche und inhaltliche Absprachen können gern getroffen werden.
                                            `,
                                            price: '39,00',
                                            restAmount:10,
                                          },
                                          {
                                            id:"195",
                                            author: "Kathrin",
                                            title: 'Keramikkurs Minischalen',
                                              start: new Date(2025, 1, 19, 16, 0),
                                              end: new Date(2025, 1, 19, 18,0),
                                              allDay: false,
                                              resource: { id: 1, details: 'Keramikkurs Minischalen' },
                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_Schalen.jpg',
                                              hexColor:'#800080',
                                              description:`
                                              Fertige kleine Minischalen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen cleanen oder einen verspielten Look kreieren, der ein kleines Schälchen zu einem zauberhaften Blickfang werden lässt. Ich zeige dir wie... 
  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weitere terminliche und inhaltliche Absprachen können gern getroffen werden.
                                              `,
                                              price: '39,00',
                                              restAmount:10,
                                            },
                                            {
                                              id:"199",
                                              author: "Kathrin",
                                              title: 'Keramikkurs Minischalen',
                                                start: new Date(2025, 1, 20, 16, 0),
                                                end: new Date(2025, 1, 20, 18,0),
                                                allDay: false,
                                                resource: { id: 1, details: 'Keramikkurs Minischalen' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_Schalen.jpg',
                                                hexColor:'#800080',
                                                description:`
                                                Fertige kleine Minischalen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen cleanen oder einen verspielten Look kreieren, der ein kleines Schälchen zu einem zauberhaften Blickfang werden lässt. Ich zeige dir wie... 
    Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weitere terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                `,
                                                price: '39,00',
                                                restAmount:10,
                                              },
                                          {
                                            id:"891",
                                            author: "Kathrin",
                                            title: 'Keramikkurs Eulen',
                                              start: new Date(2025, 2, 13, 16, 0),
                                              end: new Date(2025, 2, 13, 18,0),
                                              allDay: false,
                                              resource: { id: 1, details: 'Keramikkurs Eulen' },
                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-eule.jpeg',
                                              hexColor:'#800080',
                                              description:`
                                              Fertige kleine Keramikeulen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine süße Nachteule oder einen kleinen Kautz ganz nach deinem Geschmack formen. Ich zeige Dir wie... 
Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                              `,
                                              price: '39,00',
                                              restAmount:10,
                                            },
                                            {
                                              id:"892",
                                              author: "Kathrin",
                                              title: 'Keramikkurs Eulen',
                                                start: new Date(2025, 2, 14, 16, 0),
                                                end: new Date(2025, 2, 14, 18,0),
                                                allDay: false,
                                                resource: { id: 1, details: 'Keramikkurs Eulen' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-eule.jpeg',
                                                hexColor:'#800080',
                                                description:`
                                                Fertige kleine Keramikeulen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine süße Nachteule oder einen kleinen Kautz ganz nach deinem Geschmack formen. Ich zeige Dir wie... 
  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                `,
                                                price: '39,00',
                                                restAmount:10,
                                              },
                                              {
                                                id:"893",
                                                author: "Kathrin",
                                                title: 'Keramikkurs Eulen',
                                                  start: new Date(2025, 2, 20, 16, 0),
                                                  end: new Date(2025, 2, 13, 18,0),
                                                  allDay: false,
                                                  resource: { id: 1, details: 'Keramikkurs Eulen' },
                                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-eule.jpeg',
                                                  hexColor:'#800080',
                                                  description:`
                                                  Fertige kleine Keramikeulen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine süße Nachteule oder einen kleinen Kautz ganz nach deinem Geschmack formen. Ich zeige Dir wie... 
    Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                  `,
                                                  price: '39,00',
                                                  restAmount:10,
                                                },
                                                {
                                                  id:"894",
                                                  author: "Kathrin",
                                                  title: 'Keramikkurs Eulen',
                                                    start: new Date(2025, 2, 21, 16, 0),
                                                    end: new Date(2025, 2, 21, 18,0),
                                                    allDay: false,
                                                    resource: { id: 1, details: 'Keramikkurs Eulen' },
                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-eule.jpeg',
                                                    hexColor:'#800080',
                                                    description:`
                                                    Fertige kleine Keramikeulen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine süße Nachteule oder einen kleinen Kautz ganz nach deinem Geschmack formen. Ich zeige Dir wie... 
      Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                    `,
                                                    price: '39,00',
                                                    restAmount:10,
                                                  },
                                            {
                                              id:"881",
                                              author: "Kathrin",
                                              title: 'Keramikkurs Osterhasen',
                                                start: new Date(2025, 3, 3, 16, 0),
                                                end: new Date(2025, 3, 3, 18,0),
                                                allDay: false,
                                                resource: { id: 1, details: 'Keramikkurs Osterhasen' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-hase.jpeg',
                                                hexColor:'#800080',
                                                description:`
                                                Fertige kleine Osterhasen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine kleine Hasenfamilie töpfern, die zu Ostern durch deinen Garten hoppelt oder deiner Fensterbank ein österliches Aussehen verleiht. Ich zeige dir wie... 
Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                `,
                                                price: '39,00',
                                                restAmount:10,
                                              },
                                              {
                                                id:"882",
                                                author: "Kathrin",
                                                title: 'Keramikkurs Osterhasen',
                                                  start: new Date(2025, 3, 4, 18, 0),
                                                  end: new Date(2025, 3, 4, 20,0),
                                                  allDay: false,
                                                  resource: { id: 1, details: 'Keramikkurs Osterhasen' },
                                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-hase.jpeg',
                                                  hexColor:'#800080',
                                                  description:`
                                                  Fertige kleine Osterhasen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine kleine Hasenfamilie töpfern, die zu Ostern durch deinen Garten hoppelt oder deiner Fensterbank ein österliches Aussehen verleiht. Ich zeige dir wie... 
  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                  `,
                                                  price: '39,00',
                                                  restAmount:10,
                                                },
                                                {
                                                  id:"883",
                                                  author: "Kathrin",
                                                  title: 'Keramikkurs Osterhasen',
                                                    start: new Date(2025, 3, 7, 16, 0),
                                                    end: new Date(2025, 3, 7, 18,0),
                                                    allDay: false,
                                                    resource: { id: 1, details: 'Keramikkurs Osterhasen' },
                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-hase.jpeg',
                                                    hexColor:'#800080',
                                                    description:`
                                                    Fertige kleine Osterhasen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine kleine Hasenfamilie töpfern, die zu Ostern durch deinen Garten hoppelt oder deiner Fensterbank ein österliches Aussehen verleiht. Ich zeige dir wie... 
    Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                    `,
                                                    price: '39,00',
                                                    restAmount:10,
                                                  },
                                                  {
                                                    id:"884",
                                                    author: "Kathrin",
                                                    title: 'Keramikkurs Osterhasen',
                                                      start: new Date(2025, 3, 8, 16, 0),
                                                      end: new Date(2025, 3, 8, 18,0),
                                                      allDay: false,
                                                      resource: { id: 1, details: 'Keramikkurs Osterhasen' },
                                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-hase.jpeg',
                                                      hexColor:'#800080',
                                                      description:`
                                                      Fertige kleine Osterhasen für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine kleine Hasenfamilie töpfern, die zu Ostern durch deinen Garten hoppelt oder deiner Fensterbank ein österliches Aussehen verleiht. Ich zeige dir wie... 
      Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche und inhaltliche Absprachen können gern getroffen werden.
                                                      `,
                                                      price: '39,00',
                                                      restAmount:10,
                                                    },
                                                    {
                                                      id:"81841",
                                                      author: "Kathrin",
                                                      title: 'Keramikkurs Federleicht',
                                                        start: new Date(2025, 4, 21, 16, 0),
                                                        end: new Date(2025, 4, 21, 18,0),
                                                        allDay: false,
                                                        resource: { id: 1, details: 'Keramikkurs Federleicht' },
                                                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-feder.jpeg',
                                                        hexColor:'#800080',
                                                        description:`
                                                        Fertige schwebende und luftig leichte Federn aus Keramik für dich, für einen lieben Menschen oder als ganz Mitbringsel. Mit einigen Tricks kannst du eine Feder spielerisch leicht aussehen lassen und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie... 
Kaffee, Tee und Mineralwasser stehen  inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                        `,
                                                        price: '39,00',
                                                        restAmount:10,
                                                      },
                                                      {
                                                        id:"82841",
                                                        author: "Kathrin",
                                                        title: 'Keramikkurs Federleicht',
                                                          start: new Date(2025, 4, 20, 16, 0),
                                                          end: new Date(2025, 4, 20, 18,0),
                                                          allDay: false,
                                                          resource: { id: 1, details: 'Keramikkurs Federleicht' },
                                                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-feder.jpeg',
                                                          hexColor:'#800080',
                                                          description:`
                                                          Fertige schwebende und luftig leichte Federn aus Keramik für dich, für einen lieben Menschen oder als ganz Mitbringsel. Mit einigen Tricks kannst du eine Feder spielerisch leicht aussehen lassen und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie... 
Kaffee, Tee und Mineralwasser stehen  inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                          `,
                                                          price: '39,00',
                                                          restAmount:10,
                                                        },
                                        {
                                          id:"439",
                                          author: "Nicolle",
                                          title: 'Gestaltung Makramee-Kranz',
                                            start: new Date(2024, 11, 17, 17, 0),
                                            end: new Date(2024, 11, 17, 19,0),
                                            allDay: false,
                                            resource: { id: 1, details: 'Gestaltung Makramee-Kranz' },
                                            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_kranz.jpeg',
                                            hexColor:'#2F4F4F',
                                            description:`
                                            In gemütlicher Runde fertigt jeder seinen eigenen Makramee-Kranz. 

Alle benötigen Materialien wie hochwertiges Makrameegarn, und zum Dekorieren Holzperlen,  Naturmaterial sowie einzigartige Gussteile aus meiner Werkstatt werden gestellt und sind inklusive. 

Zum Workshop stehen kleine Snacks, Tee und Mineralwasser kostenlos zur Verfügung. 

Ein schöner Nachmittag/ Abend für Vereine,  Teams,  Freunde und alle "Kreativies".

Ich freue mich auf euch!
                                            `,
                                            price: '40,00',
                                            restAmount:10,
                                          },
                                          {
                                            id:"4391",
                                            author: "Nicolle",
                                            title: 'Gestaltung blumiges Windlicht',
                                              start: new Date(2025, 7, 2, 17, 0),
                                              end: new Date(2025, 7, 2, 19,0),
                                              allDay: false,
                                              resource: { id: 1, details: 'Gestaltung blumiges Windlicht' },
                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/blumiges Windlicht.jpeg',
                                              hexColor:'#2F4F4F',
                                              description:`
                                             Ihr fertigt Euch ein blumiges Windlicht mit sorgsam gesammelten und getrockneten Naturschönheiten.
Eine liebevolle Auswahl an Gläsern, Bändchen, Perlen, Blüten, Gräsern und Blättern stehen Euch und Eurer Fantasie zur Verfügung. 


Wählt zusätzlich einen Anhänger aus meinem modomio-Sortiment zum Dekorieren.
Freu mich drauf✨️
Bis vielleicht ganz bald
                                              `,
                                              price: '40,00',
                                              restAmount:0,
                                            },
                                          {
                                            id:"4323",
                                            author: "Marit",
                                            title: 'Kunst und Kaffee',
                                              start: new Date(2025, 1, 8, 15, 0),
                                              end: new Date(2025, 1, 8, 17,0),
                                              allDay: false,
                                              resource: { id: 1, details: 'Kunst und Kaffee' },
                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_marit.jpeg',
                                              hexColor:'#2F4F4F',
                                              description:`
                                              Kleiner Zeichen- Workshop mit der Künstlerin Marit Symalla.


Ich zeige euch wie ihr euer eigenes kleines Kunstwerk schaffen könnt und dabei genießen wir einen Kaffee oder Tee und was kleines zu naschen.





Inhalt dieses Workshops:
- grobe Zeichnung mit Buntstiften, Acryl- und Kohlestiften
- Motivauswahl und Aufbau auf dem Blatt
- Erklärung Kaffee, Kohle und Buntstifte, Wirkung aufeinander
- Auswahl der Materialien





Aufbau des Workshops:

Ich bringe fertige Acrylpapiere für die Zeichnung mit und auch unvorbereitete. Das heißt, da der Kaffee einige Zeit an Trocknung braucht, bis man auf dem Papier zeichnen kann, zeige ich euch wie ihr das auch zuhause vorbereiten könnt.

An dem Tag des Workshops, bringe ich bereits fertig bearbeitete Acrylpapiere mit Kaffee in den Größen Din A4 und A5 mit, damit wir gleich mit den Zeichnungen beginnen können. Wenn Ihr ein Lieblingsmotiv habt, bringt davon gerne Handyfotos mit. Vorzugsweise sind es kleinere Tiere oder auch Pflanzen wie Insekten, kleine Säugetiere und/oder Blumen und Gräser. Falls ihr keine direkten Wunschmotive habt, ist das auch nicht schlimm, denn ich bringe auch eine Auswahl von geeigneten Motiven mit.





Wer Fragen dazu hat, kann mir im Vorfeld gerne eine E-Mail an info@marit-symalla.de schreiben.
                                              `,
                                              price: '45,00',
                                              restAmount:8,
                                            },
                                            {
                                              id:"432331",
                                              author: "Marit",
                                              title: 'Realistische Tierzeichnung für Anfänger',
                                                start: new Date(2025, 5, 28, 15, 0),
                                                end: new Date(2025, 5, 28, 18,0),
                                                allDay: false,
                                                resource: { id: 1, details: 'Realistische Tierzeichnung für Anfänger' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop_marit2.jpeg',
                                                hexColor:'#2F4F4F',
                                                description:`
                                             Du liebst Tiere und wolltest schon immer lernen wie man ein Tier realistisch aufs Papier zu bringen?
 
In diesem Workshop zeige ich dir Schritt für Schritt, wie du aus einfachen Formen und leichten Skizzen beeindruckende Tierportraits entstehen lässt. Egal ob mit Buntstift, Kohle oder Bleistift, du brauchst nur ein wenig Zeichenerfahrung, bzw. Lust es auszuprobieren.
 
Ich zeige die meine Technik für Fellstrukturen, Glanz, lebendige Augen und ausdrucksstarke Zeichnungen.
 
 
Ich stelle alle benötigten Zeichenmaterialien.
 
Falls du mit deinen Utensilien arbeiten möchtest, kannst du diese natürlich mitbringen.
                                                `,
                                                price: '60,00',
                                                restAmount:5,
                                              },
                                            {
                                              id:"43231",
                                              author: "Simone",
                                              title: '3-D Bilder',
                                                start: new Date(2025, 2, 11, 18, 0),
                                                end: new Date(2025, 2, 11, 20,0),
                                                allDay: false,
                                                resource: { id: 1, details: '3-D Bilder' },
                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/3Dworkshop.jpeg',
                                                hexColor:'#FF8C00',
                                                description:`
                                               Gestaltet euer ganz persönliches 3-D-Bild mit zauberhaften Motiven in großer Auswahl. Egal ob florales Design, kleine Landschaft, Blumenwiese mit Schmetterlingen und Blüten…farbenfroh oder Ton in Ton…alles ist möglich. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es anfertigen. Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre erwartet euch ein Abend für alle, die Freude am kreativen Gestalten haben.


Nutzung der Stanzen, Material und 2 Rahmen sind inclusive. Jeder weitere Rahmen wird mit 5,-€ berechnet.


Auch für Kinder (ab 10 Jahren) möglich.


Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                `,
                                                price: '39,00',
                                                restAmount:12,
                                              },
                                              {
                                                id:"43232",
                                                author: "Simone",
                                                title: '3-D Bilder',
                                                  start: new Date(2025, 1, 25, 18, 0),
                                                  end: new Date(2025, 1, 25, 20,0),
                                                  allDay: false,
                                                  resource: { id: 1, details: '3-D Bilder' },
                                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/3Dworkshop.jpeg',
                                                  hexColor:'#FF8C00',
                                                  description:`
                                                 Gestaltet euer ganz persönliches 3-D-Bild mit zauberhaften Motiven in großer Auswahl. Egal ob florales Design, kleine Landschaft, Blumenwiese mit Schmetterlingen und Blüten…farbenfroh oder Ton in Ton…alles ist möglich. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es anfertigen. Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre erwartet euch ein Abend für alle, die Freude am kreativen Gestalten haben.
  
  
  Nutzung der Stanzen, Material und 2 Rahmen sind inclusive. Jeder weitere Rahmen wird mit 5,-€ berechnet.
  
  
  Auch für Kinder (ab 10 Jahren) möglich.
  
  
  Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                  `,
                                                  price: '39,00',
                                                  restAmount:12,
                                                },
                                                {
                                                  id:"43233",
                                                  author: "Simone",
                                                  title: '3-D Bilder',
                                                    start: new Date(2025, 1, 4, 18, 0),
                                                    end: new Date(2025, 1, 4, 20,0),
                                                    allDay: false,
                                                    resource: { id: 1, details: '3-D Bilder' },
                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/3Dworkshop.jpeg',
                                                    hexColor:'#FF8C00',
                                                    description:`
                                                   Gestaltet euer ganz persönliches 3-D-Bild mit zauberhaften Motiven in großer Auswahl. Egal ob florales Design, kleine Landschaft, Blumenwiese mit Schmetterlingen und Blüten…farbenfroh oder Ton in Ton…alles ist möglich. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es anfertigen. Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre erwartet euch ein Abend für alle, die Freude am kreativen Gestalten haben.
    
    
    Nutzung der Stanzen, Material und 2 Rahmen sind inclusive. Jeder weitere Rahmen wird mit 5,-€ berechnet.
    
    
    Auch für Kinder (ab 10 Jahren) möglich.
    
    
    Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                    `,
                                                    price: '39,00',
                                                    restAmount:12,
                                                  },
                                                  {
                                                    id:"43234",
                                                    author: "Simone",
                                                    title: '3-D Bilder',
                                                      start: new Date(2025, 3, 1, 18, 0),
                                                      end: new Date(2025, 3, 1, 20,0),
                                                      allDay: false,
                                                      resource: { id: 1, details: '3-D Bilder' },
                                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/3Dworkshop.jpeg',
                                                      hexColor:'#FF8C00',
                                                      description:`
                                                     Gestaltet euer ganz persönliches 3-D-Bild mit zauberhaften Motiven in großer Auswahl. Egal ob florales Design, kleine Landschaft, Blumenwiese mit Schmetterlingen und Blüten…farbenfroh oder Ton in Ton…alles ist möglich. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es anfertigen. Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre erwartet euch ein Abend für alle, die Freude am kreativen Gestalten haben.
      
      
      Nutzung der Stanzen, Material und 2 Rahmen sind inclusive. Jeder weitere Rahmen wird mit 5,-€ berechnet.
      
      
      Auch für Kinder (ab 10 Jahren) möglich.
      
      
      Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                      `,
                                                      price: '39,00',
                                                      restAmount:12,
                                                    },
                                                    {
                                                      id:"432341",
                                                      author: "Simone",
                                                      title: '3-D Bilder',
                                                        start: new Date(2025, 4, 6, 18, 0),
                                                        end: new Date(2025, 4, 6, 20,0),
                                                        allDay: false,
                                                        resource: { id: 1, details: '3-D Bilder' },
                                                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/3Dworkshop.jpeg',
                                                        hexColor:'#FF8C00',
                                                        description:`
                                                       Gestaltet euer ganz persönliches 3-D-Bild mit zauberhaften Motiven in großer Auswahl. Egal ob florales Design, kleine Landschaft, Blumenwiese mit Schmetterlingen und Blüten…farbenfroh oder Ton in Ton…alles ist möglich. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es anfertigen. Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre erwartet euch ein Abend für alle, die Freude am kreativen Gestalten haben.
        
        
        Nutzung der Stanzen, Material und 2 Rahmen sind inclusive. Jeder weitere Rahmen wird mit 5,-€ berechnet.
        
        
        Auch für Kinder (ab 10 Jahren) möglich.
        
        
        Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                        `,
                                                        price: '39,00',
                                                        restAmount:12,
                                                      },
                                                    {
                                                      id:"4323512",
                                                      author: "Simone",
                                                      title: 'Stimmungslichter',
                                                        start: new Date(2025, 1, 6, 18, 0),
                                                        end: new Date(2025, 1, 6, 20,0),
                                                        allDay: false,
                                                        resource: { id: 1, details: 'Stimmungslichter' },
                                                        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                        hexColor:'#FF8C00',
                                                        description:`
                                                    Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.


Nutzung der Stanzen, Material und 3 LEDs sind inklusive.


Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.


Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                        `,
                                                        price: '39,00',
                                                        restAmount:12,
                                                      },
                                                      {
                                                        id:"43236",
                                                        author: "Simone",
                                                        title: 'Stimmungslichter',
                                                          start: new Date(2025, 1, 27, 18, 0),
                                                          end: new Date(2025, 1, 27, 20,0),
                                                          allDay: false,
                                                          resource: { id: 1, details: 'Stimmungslichter' },
                                                          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                          hexColor:'#FF8C00',
                                                          description:`
                                                      Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.
  
  
  Nutzung der Stanzen, Material und 3 LEDs sind inklusive.
  
  
  Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.
  
  
  Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                          `,
                                                          price: '39,00',
                                                          restAmount:12,
                                                        },
                                                        {
                                                          id:"43237",
                                                          author: "Simone",
                                                          title: 'Stimmungslichter',
                                                            start: new Date(2025, 2, 12, 18, 0),
                                                            end: new Date(2025, 2, 12, 20,0),
                                                            allDay: false,
                                                            resource: { id: 1, details: 'Stimmungslichter' },
                                                            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                            hexColor:'#FF8C00',
                                                            description:`
                                                        Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.
    
    
    Nutzung der Stanzen, Material und 3 LEDs sind inklusive.
    
    
    Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.
    
    
    Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                            `,
                                                            price: '39,00',
                                                            restAmount:12,
                                                          },
                                                          {
                                                            id:"4323522",
                                                            author: "Simone",
                                                            title: 'Stimmungslichter',
                                                              start: new Date(2025, 3, 2, 18, 0),
                                                              end: new Date(2025, 3, 2, 20,0),
                                                              allDay: false,
                                                              resource: { id: 1, details: 'Stimmungslichter' },
                                                              titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                              hexColor:'#FF8C00',
                                                              description:`
                                                          Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.
      
      
      Nutzung der Stanzen, Material und 3 LEDs sind inklusive.
      
      
      Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.
      
      
      Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                              `,
                                                              price: '39,00',
                                                              restAmount:12,
                                                            },
                                                            {
                                                              id:"432358",
                                                              author: "Simone",
                                                              title: 'Stimmungslichter',
                                                                start: new Date(2025, 4, 7, 18, 0),
                                                                end: new Date(2025, 4, 7, 20,0),
                                                                allDay: false,
                                                                resource: { id: 1, details: 'Stimmungslichter' },
                                                                titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                                hexColor:'#FF8C00',
                                                                description:`
                                                            Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.
        
        
        Nutzung der Stanzen, Material und 3 LEDs sind inklusive.
        
        
        Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.
        
        
        Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                                `,
                                                                price: '39,00',
                                                                restAmount:12,
                                                              },
                                                              {
                                                                id:"43235",
                                                                author: "Simone",
                                                                title: 'Stimmungslichter',
                                                                  start: new Date(2025, 3, 2, 18, 0),
                                                                  end: new Date(2025, 3, 2, 20,0),
                                                                  allDay: false,
                                                                  resource: { id: 1, details: 'Stimmungslichter' },
                                                                  titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/StimmungslichterWorkshop.jpeg',
                                                                  hexColor:'#FF8C00',
                                                                  description:`
                                                              Gestaltet eure ganz persönlichen Stimmungslichter mit einer großen Auswahl an wunderschönen, individuellen Motiven. Die Lichter können in zwei verschiedenen Größen angefertigt werden, so dass man auch ein kleines Set zusammenstellen kann. Oder vielleicht sucht ihr noch ein originelles, ganz persönliches Geschenk? Hier könnt ihr es herstellen! Bei Kaffee, Tee oder Limonade und gemütlicher Atmosphäre zeige ich euch, wie diese zauberhaften Lichter angefertigt werden.
          
          
          Nutzung der Stanzen, Material und 3 LEDs sind inklusive.
          
          
          Die Veranstaltung ist auch für Kinder (ab 11 Jahre) möglich.
          
          
          Möchten Sie die Veranstaltung als individuellen Termin für ihre Gruppe buchen? Kontaktieren Sie mich gerne!
                                                                  `,
                                                                  price: '39,00',
                                                                  restAmount:12,
                                                                },
                                                                {
                                                                  id:"43235855",
                                                                  author: "Benjamin",
                                                                  title: 'Wein und Posie',
                                                                    start: new Date(2025, 4, 9, 19, 0),
                                                                    end: new Date(2025, 4, 9, 21,0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Wein und Posie' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/weinpoesie.jpeg',
                                                                    hexColor:'#98ff98',
                                                                    description:`
                                                                Weinverkostung und Lyriklesung


Eine Kombination der besonderen Art. Das Weinhaus Groß – ein Winzer aus Putzkau – trifft auf Dienemann – einen Dichter aus Bautzen. Sie bekommen die verschiedenen Weine vom Winzer persönlich zur Verkostung präsentiert und dazu die Lyrik von Dienemann vorgetragen. Wein und Lyrik aus der Region an einem Abend.
                                                                    `,
                                                                    price: '25,00',
                                                                    restAmount:12,
                                                                  },{
                                                                    id:"18441552231140",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Familie',
                                                                    start: new Date(2025, 5, 11, 16, 0),
                                                                    end: new Date(2025, 5, 11, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Familie' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Familie.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Miniaturausgabe deiner Familie aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du deine eigene Familie oder andere liebe Menschen spielerisch in Ton abbilden und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231141",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Familie',
                                                                    start: new Date(2025, 5, 12, 16, 0),
                                                                    end: new Date(2025, 5, 12, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Familie' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Familie.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Miniaturausgabe deiner Familie aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du deine eigene Familie oder andere liebe Menschen spielerisch in Ton abbilden und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231142",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Familie',
                                                                    start: new Date(2025, 5, 17, 16, 0),
                                                                    end: new Date(2025, 5, 17, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Familie' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Familie.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Miniaturausgabe deiner Familie aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du deine eigene Familie oder andere liebe Menschen spielerisch in Ton abbilden und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231143",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Familie',
                                                                    start: new Date(2025, 5, 18, 16, 0),
                                                                    end: new Date(2025, 5, 18, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Familie' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Familie.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Miniaturausgabe deiner Familie aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du deine eigene Familie oder andere liebe Menschen spielerisch in Ton abbilden und dir ein ungewöhnliches Deko-Objekt töpfern. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231144",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Türschild',
                                                                    start: new Date(2025, 6, 15, 16, 0),
                                                                    end: new Date(2025, 6, 15, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Türschild' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Tuerschild.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Türschild für ein Haus/eine Wohnung aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine ungewöhnliche und individuelle Visitenkarte deiner Bleibe spielerisch in Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231145",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Türschild',
                                                                    start: new Date(2025, 6, 16, 16, 0),
                                                                    end: new Date(2025, 6, 16, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Türschild' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Tuerschild.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Türschild für ein Haus/eine Wohnung aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine ungewöhnliche und individuelle Visitenkarte deiner Bleibe spielerisch in Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231146",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Türschild',
                                                                    start: new Date(2025, 6, 22, 16, 0),
                                                                    end: new Date(2025, 6, 22, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Türschild' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Tuerschild.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Türschild für ein Haus/eine Wohnung aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine ungewöhnliche und individuelle Visitenkarte deiner Bleibe spielerisch in Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231147",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Türschild',
                                                                    start: new Date(2025, 6, 23, 16, 0),
                                                                    end: new Date(2025, 6, 23, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Türschild' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Tuerschild.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Türschild für ein Haus/eine Wohnung aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du eine ungewöhnliche und individuelle Visitenkarte deiner Bleibe spielerisch in Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231148",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Gartenspitze',
                                                                    start: new Date(2025, 7, 12, 16, 0),
                                                                    end: new Date(2025, 7, 12, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Gartenspitze' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Gartenspitze.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Gartenspitze aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen ungewöhnlichen Hingucker für einen Garten, einen Balkon oder für eine einsame Zimmerpflanze aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231149",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Gartenspitze',
                                                                    start: new Date(2025, 7, 13, 16, 0),
                                                                    end: new Date(2025, 7, 13, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Gartenspitze' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Gartenspitze.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Gartenspitze aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen ungewöhnlichen Hingucker für einen Garten, einen Balkon oder für eine einsame Zimmerpflanze aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231150",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Gartenspitze',
                                                                    start: new Date(2025, 7, 19, 16, 0),
                                                                    end: new Date(2025, 7, 19, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Gartenspitze' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Gartenspitze.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Gartenspitze aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen ungewöhnlichen Hingucker für einen Garten, einen Balkon oder für eine einsame Zimmerpflanze aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231151",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Gartenspitze',
                                                                    start: new Date(2025, 7, 20, 16, 0),
                                                                    end: new Date(2025, 7, 20, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Gartenspitze' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Gartenspitze.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Gartenspitze aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen ungewöhnlichen Hingucker für einen Garten, einen Balkon oder für eine einsame Zimmerpflanze aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231152",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Minischalentiere',
                                                                    start: new Date(2025, 9, 9, 16, 0),
                                                                    end: new Date(2025, 9, 9, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Minischalentiere' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Minischalentiere.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Schalentier deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen Hund ohne Schuhtick, einen flugunfähigen Vogel oder ein Schweinchen mit Glücksgarantie aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231153",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Minischalentiere',
                                                                    start: new Date(2025, 9, 10, 16, 0),
                                                                    end: new Date(2025, 9, 10, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Minischalentiere' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Minischalentiere.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Schalentier deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen Hund ohne Schuhtick, einen flugunfähigen Vogel oder ein Schweinchen mit Glücksgarantie aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231154",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Minischalentiere',
                                                                    start: new Date(2025, 9, 16, 16, 0),
                                                                    end: new Date(2025, 9, 16, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Minischalentiere' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Minischalentiere.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Schalentier deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen Hund ohne Schuhtick, einen flugunfähigen Vogel oder ein Schweinchen mit Glücksgarantie aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231155",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Minischalentiere',
                                                                    start: new Date(2025, 9, 17, 16, 0),
                                                                    end: new Date(2025, 9, 17, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Minischalentiere' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Minischalentiere.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige ein Schalentier deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen Hund ohne Schuhtick, einen flugunfähigen Vogel oder ein Schweinchen mit Glücksgarantie aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231156",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Blumenkachel/Fliese',
                                                                    start: new Date(2025, 8, 9, 16, 0),
                                                                    end: new Date(2025, 8, 9, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Blumenkachel/Fliese' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Blumenkachel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Kachel/Fliese deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen dekorativen Hingucker für dein Gartenhaus, deine Küche oder deine gemütliche Sitzecke aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231157",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Blumenkachel/Fliese',
                                                                    start: new Date(2025, 8, 10, 16, 0),
                                                                    end: new Date(2025, 8, 10, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Blumenkachel/Fliese' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Blumenkachel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Kachel/Fliese deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen dekorativen Hingucker für dein Gartenhaus, deine Küche oder deine gemütliche Sitzecke aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231158",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Blumenkachel/Fliese',
                                                                    start: new Date(2025, 8, 16, 16, 0),
                                                                    end: new Date(2025, 8, 16, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Blumenkachel/Fliese' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Blumenkachel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Kachel/Fliese deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen dekorativen Hingucker für dein Gartenhaus, deine Küche oder deine gemütliche Sitzecke aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231159",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Blumenkachel/Fliese',
                                                                    start: new Date(2025, 8, 17, 16, 0),
                                                                    end: new Date(2025, 8, 17, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Blumenkachel/Fliese' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Blumenkachel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige eine Kachel/Fliese deiner Wahl aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen dekorativen Hingucker für dein Gartenhaus, deine Küche oder deine gemütliche Sitzecke aus Ton gestalten. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231160",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Engel',
                                                                    start: new Date(2025, 10, 11, 16, 0),
                                                                    end: new Date(2025, 10, 11, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Engel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Engel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen zauberhaften Engel aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Glücksengel mit Federflügeln aus Ton gestalten, der dich und deine Lieben im Auge behält und ein kleines Lächeln herzaubern kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231161",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Engel',
                                                                    start: new Date(2025, 10, 12, 16, 0),
                                                                    end: new Date(2025, 10, 12, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Engel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Engel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen zauberhaften Engel aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Glücksengel mit Federflügeln aus Ton gestalten, der dich und deine Lieben im Auge behält und ein kleines Lächeln herzaubern kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231162",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Engel',
                                                                    start: new Date(2025, 10, 18, 16, 0),
                                                                    end: new Date(2025, 10, 18, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Engel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Engel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen zauberhaften Engel aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Glücksengel mit Federflügeln aus Ton gestalten, der dich und deine Lieben im Auge behält und ein kleines Lächeln herzaubern kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231163",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Engel',
                                                                    start: new Date(2025, 10, 19, 16, 0),
                                                                    end: new Date(2025, 10, 19, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Engel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Engel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen zauberhaften Engel aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Glücksengel mit Federflügeln aus Ton gestalten, der dich und deine Lieben im Auge behält und ein kleines Lächeln herzaubern kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231164",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Weihnachtskugel',
                                                                    start: new Date(2025, 11, 9, 16, 0),
                                                                    end: new Date(2025, 11, 9, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Weihnachtskugel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Weihnachtskugel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen kleinen Weihnachtsmann aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Mann im saisonalen Outfit töpfern, der ganz sicher selbst ein besonderes Geschenk sein kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231165",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Weihnachtskugel',
                                                                    start: new Date(2025, 11, 10, 16, 0),
                                                                    end: new Date(2025, 11, 10, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Weihnachtskugel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Weihnachtskugel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen kleinen Weihnachtsmann aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Mann im saisonalen Outfit töpfern, der ganz sicher selbst ein besonderes Geschenk sein kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231166",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Weihnachtskugel',
                                                                    start: new Date(2025, 11, 16, 16, 0),
                                                                    end: new Date(2025, 11, 16, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Weihnachtskugel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Weihnachtskugel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen kleinen Weihnachtsmann aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Mann im saisonalen Outfit töpfern, der ganz sicher selbst ein besonderes Geschenk sein kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                    
                                                                  {
                                                                    id:"18441552231167",
                                                                    author: "Kathrin",
                                                                    title: 'Keramikkurs Weihnachtskugel',
                                                                    start: new Date(2025, 11, 17, 16, 0),
                                                                    end: new Date(2025, 11, 17, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Keramikkurs Weihnachtskugel' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-Weihnachtskugel.jpeg',
                                                                    hexColor:'#800080',
                                                                    description:`
                                                                  Fertige einen kleinen Weihnachtsmann aus Keramik für dich, für einen lieben Menschen oder als Mitbringsel. Mit einigen Tricks kannst du einen kleinen Mann im saisonalen Outfit töpfern, der ganz sicher selbst ein besonderes Geschenk sein kann. Ich zeige dir wie...
                                                                  Kaffee, Tee und Mineralwasser stehen inklusive zur Verfügung. Weiter terminliche Absprachen oder das Fertigen anderer Objekte kann gern besprochen und abgestimmt werden.
                                                                    `,
                                                                    price: '39,00',
                                                                    restAmount:10,
                                                                  },
                                                                  {
                                                                    id:"184428724231169",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Schmuck mit Ка • Ma',
                                                                    start: new Date(2026, 1, 15, 14, 0),
                                                                    end: new Date(2026, 1, 15, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Schmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-schmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Wir laden dich herzlich zu unserem kreativen Workshop ein, in dem du die Möglichkeit hast, 12 einzigartige florale Anhänger aus Kaltkeramik zu gestalten.
                                                                  In einer inspirierenden Atmosphäre wirst du Schritt für Schritt angeleitet, deine eigenen Anhänger zu fertigen und deiner Kreativität freien Lauf zu lassen.
                                                                  
                                                                  Nachdem du deine individuellen Anhänger kreiert hast, geht es an die Veredelung! Mit elegantem Gold- und Kupfer-Effekt verleihst du deinen Kreationen einen besonderen Glanz.
                                                                  
                                                                  Anschließend kannst du deine Anhänger an einer wunderschönen Kette anbringen, die dich jeden Monat anders strahlen lässt und zu verschiedenen Anlässen kombiniert werden kann.
                                                                  
                                                                  Egal, ob du Anfänger oder bereits erfahren im Schmuckdesign bist, dieser Workshop bietet die perfekte Gelegenheit, neue Fähigkeiten zu erlernen und Spaß zu haben. Wir freuen uns auf deine Teilnahme und darauf, gemeinsam etwas Wunderschönes zu schaffen!
                                                                  
                                                                  Teilnehmer 8
                                                                  Dauer 2,5 h
                                                                  Preis 49,00 €
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231170",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Schmuck mit Ка • Ma',
                                                                  start: new Date(2026, 1, 1, 14, 0),
                                                                    end: new Date(2026, 1, 1, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Schmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-schmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Wir laden dich herzlich zu unserem kreativen Workshop ein, in dem du die Möglichkeit hast, 12 einzigartige florale Anhänger aus Kaltkeramik zu gestalten.
                                                                  In einer inspirierenden Atmosphäre wirst du Schritt für Schritt angeleitet, deine eigenen Anhänger zu fertigen und deiner Kreativität freien Lauf zu lassen.
                                                                  
                                                                  Nachdem du deine individuellen Anhänger kreiert hast, geht es an die Veredelung! Mit elegantem Gold- und Kupfer-Effekt verleihst du deinen Kreationen einen besonderen Glanz.
                                                                  
                                                                  Anschließend kannst du deine Anhänger an einer wunderschönen Kette anbringen, die dich jeden Monat anders strahlen lässt und zu verschiedenen Anlässen kombiniert werden kann.
                                                                  
                                                                  Egal, ob du Anfänger oder bereits erfahren im Schmuckdesign bist, dieser Workshop bietet die perfekte Gelegenheit, neue Fähigkeiten zu erlernen und Spaß zu haben. Wir freuen uns auf deine Teilnahme und darauf, gemeinsam etwas Wunderschönes zu schaffen!
                                                                  
                                                                  Teilnehmer 8
                                                                  Dauer 2,5 h
                                                                  Preis 49,00 €
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231171",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Schmuck mit Ка • Ma',
                                                                    start: new Date(2025, 8, 27, 14, 0),
                                                                    end: new Date(2025, 8, 27, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Schmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-schmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Wir laden dich herzlich zu unserem kreativen Workshop ein, in dem du die Möglichkeit hast, 12 einzigartige florale Anhänger aus Kaltkeramik zu gestalten.
                                                                  In einer inspirierenden Atmosphäre wirst du Schritt für Schritt angeleitet, deine eigenen Anhänger zu fertigen und deiner Kreativität freien Lauf zu lassen.
                                                                  
                                                                  Nachdem du deine individuellen Anhänger kreiert hast, geht es an die Veredelung! Mit elegantem Gold- und Kupfer-Effekt verleihst du deinen Kreationen einen besonderen Glanz.
                                                                  
                                                                  Anschließend kannst du deine Anhänger an einer wunderschönen Kette anbringen, die dich jeden Monat anders strahlen lässt und zu verschiedenen Anlässen kombiniert werden kann.
                                                                  
                                                                  Egal, ob du Anfänger oder bereits erfahren im Schmuckdesign bist, dieser Workshop bietet die perfekte Gelegenheit, neue Fähigkeiten zu erlernen und Spaß zu haben. Wir freuen uns auf deine Teilnahme und darauf, gemeinsam etwas Wunderschönes zu schaffen!
                                                                  
                                                                  Teilnehmer 8
                                                                  Dauer 2,5 h
                                                                  Preis 49,00 €
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231172",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Schmuck mit Ка • Ma',
                                                                    start: new Date(2025, 9, 5, 14, 0),
                                                                    end: new Date(2025, 9, 5, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Schmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-schmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Wir laden dich herzlich zu unserem kreativen Workshop ein, in dem du die Möglichkeit hast, 12 einzigartige florale Anhänger aus Kaltkeramik zu gestalten.
                                                                  In einer inspirierenden Atmosphäre wirst du Schritt für Schritt angeleitet, deine eigenen Anhänger zu fertigen und deiner Kreativität freien Lauf zu lassen.
                                                                  
                                                                  Nachdem du deine individuellen Anhänger kreiert hast, geht es an die Veredelung! Mit elegantem Gold- und Kupfer-Effekt verleihst du deinen Kreationen einen besonderen Glanz.
                                                                  
                                                                  Anschließend kannst du deine Anhänger an einer wunderschönen Kette anbringen, die dich jeden Monat anders strahlen lässt und zu verschiedenen Anlässen kombiniert werden kann.
                                                                  
                                                                  Egal, ob du Anfänger oder bereits erfahren im Schmuckdesign bist, dieser Workshop bietet die perfekte Gelegenheit, neue Fähigkeiten zu erlernen und Spaß zu haben. Wir freuen uns auf deine Teilnahme und darauf, gemeinsam etwas Wunderschönes zu schaffen!
                                                                  
                                                                  Teilnehmer 8
                                                                  Dauer 2,5 h
                                                                  Preis 49,00 €
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  
                                                                 
                                                                  
                                                                  {
                                                                    id:"18441552231174",
                                                                    author: "Kati",
                                                                    title: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben',
                                                                    start: new Date(2026, 8, 6, 14, 0),
                                                                    end: new Date(2026, 8, 6, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopSuminagashi.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Suminagashi-Workshop in der StadtWERKSTATT 

Kunst auf Wasser erleben!

Entdecke die faszinierende Kunst des Suminagashi und tauche ein in eine Welt der Kreativität! 
Bei diesem Workshop lernst du, wie du mit minimalen Impulsen wunderschöne, organische Muster auf handgeschöpftem Papier erzeugen kannst. Von filigranen Jahresringen bis hin zu komplexen Muschelstrukturen und mäandernden Flüssen – die Möglichkeiten sind nahezu unendlich!


Was dich erwartet:


-Achtsame Kreativität:
Der Workshop bietet eine wunderbare Gelegenheit, zur Ruhe zu kommen. Während du mit Wasser und Tinte arbeitest, kannst du deinen Geist beruhigen und neue Ideen sprießen lassen.
  


-Ein ganzheitliches Erlebnis:
 Suminagashi verbindet Kunst und Achtsamkeit. Es wird nicht nur ein Kunstwerk geschaffen, erlebe wie die zarten Muster des Suminagashi nicht nur die Oberfläche des Papiers verschönern, sondern auch deine innere Ruhe stärken. Komm vorbei und lass dich von der Magie des Wassers und der Tinte inspirieren!


-Für wen ist der Kurs geeignet?
Suminagashi heißt alle willkommen! Es ist ideal für Einzelpersonen, Familien, Kinder,  Studenten und sogar als Teambuilding-Aktivität. 



Was ist im Workshop enthalten? 


	•	Alle Werkzeuge und Materialien werden für den Gebrauch während des Workshops zur Verfügung gestellt. 
	•	Praktische Anleitung und Tipps von Kati 
	•	Deine eigenen marmorierten Kreationen zum Mitnehmen.
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  {
                                                                    id:"18441554662231174",
                                                                    author: "Kati",
                                                                    title: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben',
                                                                    start: new Date(2026, 8, 27, 14, 0),
                                                                    end: new Date(2026, 8, 27, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopSuminagashi.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Suminagashi-Workshop in der StadtWERKSTATT 

Kunst auf Wasser erleben!

Entdecke die faszinierende Kunst des Suminagashi und tauche ein in eine Welt der Kreativität! 
Bei diesem Workshop lernst du, wie du mit minimalen Impulsen wunderschöne, organische Muster auf handgeschöpftem Papier erzeugen kannst. Von filigranen Jahresringen bis hin zu komplexen Muschelstrukturen und mäandernden Flüssen – die Möglichkeiten sind nahezu unendlich!


Was dich erwartet:


-Achtsame Kreativität:
Der Workshop bietet eine wunderbare Gelegenheit, zur Ruhe zu kommen. Während du mit Wasser und Tinte arbeitest, kannst du deinen Geist beruhigen und neue Ideen sprießen lassen.
  


-Ein ganzheitliches Erlebnis:
 Suminagashi verbindet Kunst und Achtsamkeit. Es wird nicht nur ein Kunstwerk geschaffen, erlebe wie die zarten Muster des Suminagashi nicht nur die Oberfläche des Papiers verschönern, sondern auch deine innere Ruhe stärken. Komm vorbei und lass dich von der Magie des Wassers und der Tinte inspirieren!


-Für wen ist der Kurs geeignet?
Suminagashi heißt alle willkommen! Es ist ideal für Einzelpersonen, Familien, Kinder,  Studenten und sogar als Teambuilding-Aktivität. 



Was ist im Workshop enthalten? 


	•	Alle Werkzeuge und Materialien werden für den Gebrauch während des Workshops zur Verfügung gestellt. 
	•	Praktische Anleitung und Tipps von Kati 
	•	Deine eigenen marmorierten Kreationen zum Mitnehmen.
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  {
                                                                    id:"1844155223464631174",
                                                                    author: "Kati",
                                                                    title: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben',
                                                                    start: new Date(2026, 10, 1, 14, 0),
                                                                    end: new Date(2026, 10, 1, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopSuminagashi.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Suminagashi-Workshop in der StadtWERKSTATT 

Kunst auf Wasser erleben!

Entdecke die faszinierende Kunst des Suminagashi und tauche ein in eine Welt der Kreativität! 
Bei diesem Workshop lernst du, wie du mit minimalen Impulsen wunderschöne, organische Muster auf handgeschöpftem Papier erzeugen kannst. Von filigranen Jahresringen bis hin zu komplexen Muschelstrukturen und mäandernden Flüssen – die Möglichkeiten sind nahezu unendlich!


Was dich erwartet:


-Achtsame Kreativität:
Der Workshop bietet eine wunderbare Gelegenheit, zur Ruhe zu kommen. Während du mit Wasser und Tinte arbeitest, kannst du deinen Geist beruhigen und neue Ideen sprießen lassen.
  


-Ein ganzheitliches Erlebnis:
 Suminagashi verbindet Kunst und Achtsamkeit. Es wird nicht nur ein Kunstwerk geschaffen, erlebe wie die zarten Muster des Suminagashi nicht nur die Oberfläche des Papiers verschönern, sondern auch deine innere Ruhe stärken. Komm vorbei und lass dich von der Magie des Wassers und der Tinte inspirieren!


-Für wen ist der Kurs geeignet?
Suminagashi heißt alle willkommen! Es ist ideal für Einzelpersonen, Familien, Kinder,  Studenten und sogar als Teambuilding-Aktivität. 



Was ist im Workshop enthalten? 


	•	Alle Werkzeuge und Materialien werden für den Gebrauch während des Workshops zur Verfügung gestellt. 
	•	Praktische Anleitung und Tipps von Kati 
	•	Deine eigenen marmorierten Kreationen zum Mitnehmen.
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  {
                                                                    id:"18441552376346231174",
                                                                    author: "Kati",
                                                                    title: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben',
                                                                    start: new Date(2026, 10, 21, 14, 0),
                                                                    end: new Date(2026, 10, 21, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Suminagashi-Workshop in Bautzen Kunst auf Wasser erleben' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopSuminagashi.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Suminagashi-Workshop in der StadtWERKSTATT 

Kunst auf Wasser erleben!

Entdecke die faszinierende Kunst des Suminagashi und tauche ein in eine Welt der Kreativität! 
Bei diesem Workshop lernst du, wie du mit minimalen Impulsen wunderschöne, organische Muster auf handgeschöpftem Papier erzeugen kannst. Von filigranen Jahresringen bis hin zu komplexen Muschelstrukturen und mäandernden Flüssen – die Möglichkeiten sind nahezu unendlich!


Was dich erwartet:


-Achtsame Kreativität:
Der Workshop bietet eine wunderbare Gelegenheit, zur Ruhe zu kommen. Während du mit Wasser und Tinte arbeitest, kannst du deinen Geist beruhigen und neue Ideen sprießen lassen.
  


-Ein ganzheitliches Erlebnis:
 Suminagashi verbindet Kunst und Achtsamkeit. Es wird nicht nur ein Kunstwerk geschaffen, erlebe wie die zarten Muster des Suminagashi nicht nur die Oberfläche des Papiers verschönern, sondern auch deine innere Ruhe stärken. Komm vorbei und lass dich von der Magie des Wassers und der Tinte inspirieren!


-Für wen ist der Kurs geeignet?
Suminagashi heißt alle willkommen! Es ist ideal für Einzelpersonen, Familien, Kinder,  Studenten und sogar als Teambuilding-Aktivität. 



Was ist im Workshop enthalten? 


	•	Alle Werkzeuge und Materialien werden für den Gebrauch während des Workshops zur Verfügung gestellt. 
	•	Praktische Anleitung und Tipps von Kati 
	•	Deine eigenen marmorierten Kreationen zum Mitnehmen.
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  {
                                                                    id:"18441552231175",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Schmuck mit Ка • Ma',
                                                                    start: new Date(2025, 11, 5, 17, 0),
                                                                    end: new Date(2025, 11, 5, 19, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Schmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-schmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Wir laden dich herzlich zu unserem kreativen Workshop ein, in dem du die Möglichkeit hast, 12 einzigartige florale Anhänger aus Kaltkeramik zu gestalten.
                                                                  In einer inspirierenden Atmosphäre wirst du Schritt für Schritt angeleitet, deine eigenen Anhänger zu fertigen und deiner Kreativität freien Lauf zu lassen.
                                                                  
                                                                  Nachdem du deine individuellen Anhänger kreiert hast, geht es an die Veredelung! Mit elegantem Gold- und Kupfer-Effekt verleihst du deinen Kreationen einen besonderen Glanz.
                                                                  
                                                                  Anschließend kannst du deine Anhänger an einer wunderschönen Kette anbringen, die dich jeden Monat anders strahlen lässt und zu verschiedenen Anlässen kombiniert werden kann.
                                                                  
                                                                  Egal, ob du Anfänger oder bereits erfahren im Schmuckdesign bist, dieser Workshop bietet die perfekte Gelegenheit, neue Fähigkeiten zu erlernen und Spaß zu haben. Wir freuen uns auf deine Teilnahme und darauf, gemeinsam etwas Wunderschönes zu schaffen!
                                                                  
                                                                  Teilnehmer 8
                                                                  Dauer 2,5 h
                                                                  Preis 49,00 €
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:8,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231176",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 9, 11, 14, 0),
                                                                    end: new Date(2025, 9, 11, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:9,
                                                                  },
                                                                  
                                                                  
                                                                  
                                                                  {
                                                                    id:"18441552231178",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 10, 1, 14, 0),
                                                                    end: new Date(2025, 10, 1, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:7,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231179",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 10, 2, 14, 0),
                                                                    end: new Date(2025, 10, 2, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:9,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231180",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 10, 8, 14, 0),
                                                                    end: new Date(2025, 10, 8, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:0,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231181",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 10, 30, 14, 0),
                                                                    end: new Date(2025, 10, 30, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:4,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231182",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 11, 6, 14, 0),
                                                                    end: new Date(2025, 11, 6, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:9,
                                                                  },
                                                                  
                                                                  {
                                                                    id:"18441552231183",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 11, 11, 18, 0),
                                                                    end: new Date(2025, 11, 11, 20, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:6,
                                                                  },
                                                                  
                                                                  
                                                                  
                                                                  {
                                                                    id:"18441552231185",
                                                                    author: "Kati",
                                                                    title: 'Workshop: Weihnachtsschmuck mit Ка • Ma',
                                                                    start: new Date(2025, 11, 18, 16, 0),
                                                                    end: new Date(2025, 11, 18, 18, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Workshop: Weihnachtsschmuck mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshop-weihnachtsschmuck-ka-ma.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Bist du bereit für eine kreative Auszeit in der besinnlichen Weihnachtszeit? In unserem Workshop hast du die Möglichkeit, 8 verschiedene und einzigartige Weihnachtsanhänger aus Kaltkeramik zu gestalten. Du lernst, wie du diese Anhänger mit wunderschönen CHARMS und stilvollen Bändern verzierten kannst, um ihnen einen persönlichen und festlichen Touch zu verleihen.
                                                                  
                                                                  Die wunderschönen Anhänger sind nicht nur als Schmuck für dein Zuhause ein echter Blickfang, sondern eignen sich auch perfekt als liebevolle Geschenke für Familie und Freunde. Mach es dir gemütlich und genieße die entspannte Atmosphäre, während du deiner Kreativität freien Lauf lässt.
                                                                  
                                                                  Dieser Workshop ist ideal für eine kleine Weihnachtsfeier im Kreise deines Teams oder deiner Freunde. Gemeinsam könnt ihr kreative Ideen austauschen, lachen und eine schöne Zeit verbringen. Egal, ob du schon Erfahrung im kreativen Gestalten hast oder Anfänger bist – jeder ist herzlich willkommen!
                                                                  
                                                                  Melde dich jetzt an und sichere dir deinen Platz in unserer festlichen Kreativsession. Wir freuen uns darauf, mit dir zusammen eine unvergessliche Workshop-Erfahrung zu schaffen!
                                                                  
                                                                  Teilnehmer 9
                                                                  Dauer 2,5 h 
                                                                  Preis 49,-€
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:9,
                                                                  },
                                                                  {
                                                                    id:"184415522311691",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                     start: '',
             end: '',
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus1.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:12,
                                                                  },
                                                                  {
                                                                    id:"184415522311692",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2026, 1, 27, 16, 0),
                                                                    end: new Date(2026, 1, 27, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus1.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '40,00',
                                                                    restAmount:0,
                                                                  },
                                                                  {
                                                                    id:"184415522311693",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2026, 2, 15, 16, 0),
                                                                    end: new Date(2026, 2, 15, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus2.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '40,00',
                                                                    restAmount:0,
                                                                  },
                                                                  {
                                                                    id:"184415522311694",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2025, 9, 23, 18, 0),
                                                                    end: new Date(2025, 9, 23, 20, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus3.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '40,00',
                                                                    restAmount:12,
                                                                  },
                                                                     {
                                                                    id:"1844555223116941",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2026, 0, 9, 16, 0),
                                                                    end: new Date(2026, 0, 9, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus3.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:0,
                                                                  },
                                                                              {
                                                                    id:"1845425223116941",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2026, 0, 10, 14, 0),
                                                                    end: new Date(2026, 0, 10, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus3.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:12,
                                                                  },
                                                                   {
                                                                    id:"1845732116941",
                                                                    author: "Kati",
                                                                    title: 'Lichter-Häuser gestalten mit Ка • Ma',
                                                                    start: new Date(2026, 0, 24, 14, 0),
                                                                    end: new Date(2026, 0, 24, 16, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Lichter-Häuser gestalten mit Ка • Ma' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichthaus3.PNG',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Tauche ein in die funkelnde Welt der Lichter. Beim Lichter-Häuser Workshop fertigen wir vier verschiedene kleine Häuser aus Kaltkeramik – individuell geformt, gestaltet und später hell erleuchtet. 


Verleihe jedem Haus seinen eigenen Stil: Schmücke mit Bändern, Perlen und kleinen Anhängern in vielfältigen Designs. 


Im Preis enthalten sind Mineralwasser, Tee, Kaffee sowie alle Materialien, die du zum Basteln brauchst. Vorkenntnisse sind nicht nötig – komm einfach vorbei, lass dich inspirieren und werde kreativ. 
                                                                    `,
                                                                    price: '49,00',
                                                                    restAmount:12,
                                                                  },
                                                                  {
                                                                    id:"1844155223116941",
                                                                    author: "Kati",
                                                                    title: 'Kreativ Geburtstag mit Ei-der-Daus ',
                                                                    start: new Date(2025,10, 29, 17, 0),
                                                                    end: new Date(2025, 10, 29, 19, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Kreativ Geburtstag mit Ei-der-Daus ' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/Workshop_Kati.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Erlebe deinen kreativen Geburtstag mit Ei-der-Daus in der gemütlichen StadtWERKSTATT Bautzen. 
                                                                  
                                                                  Fertigt gemeinsam mit euren Geburtstagsgästen euer persönliches Osterei an – verziert mit wunderbaren Anhängern und Bändern. Eine passende Geschenkverpackung ist inklusive. 
                                                                  
                                                                  Verbringt eine unvergessliche Zeit mit euren Lieblingsmenschen. Geeignet ab 6 Jahren bis 99 Jahre.


                                                                  Interessiert? Anfragen und Buchungen über Kati Schmidt:
 Telefon: 0176/50494712
                                                                    `,
                                                                    price: '40,00',
                                                                    restAmount:'0',
                                                                  },
                                                                  {
                                                                    id:"18441552231169412",
                                                                    author: "Kati",
                                                                    title: 'Weihnachtmarkt in der StadWERKSTATT',
                                                                    start: new Date(2025,11, 20, 10, 0),
                                                                    end: new Date(2025, 11, 20, 21, 30),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Weihnachtmarkt in der StadWERKSTATT' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/weihnachtsmarkt.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                  Am 20. Dezember 2025 lädt die StadWERKSTATT von 10:00 bis 21:30 Uhr zum Weihnachtmarkt ein. 
                                                                  
                                                                  Taucht ein in eine gemütliche und festliche Atmosphäre, entdeckt ausgewählte handgefertigte Geschenke und Kleinigkeiten rund um Weihnachten für eure Lieblingsmenschen. 
                                                                  Lasst euch verwöhnen mit Glühwein vom Weinhaus Gross, Honig-Whisky-Met, Kaffee, Tee, Pfefferkuchen und Plätzchen. 
                                                                  
                                                                  Gemeinsam sammeln wir Spenden für die Kinderarche in der Oberlausitz – jeder Cent zählt. 
                                                                 
                                                                  Wir freuen uns auf euch! Kati Schmidt & das gesamte Team der StadWERKSTATT `,
                                                                    price: '0,00',
                                                                    restAmount:'100',
                                                                  },
                                                                  
                                                                  {
                                                                    id:"1844155223116942",
                                                                    author: "Kati",
                                                                    title: 'Advent in deiner StadtWERKSTATT',
                                                                    start: new Date(2025,10, 30, 12, 0),
                                                                    end: new Date(2025, 10, 30, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Advent in deiner StadtWERKSTATT' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/advent3.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                 Erstmals öffnen wir an zwei Adventssonntagen die Türen der Stadtwerkstatt: 
                                                                 Am 1. Advent und am 3. Advent, jeweils von 12 bis 18 Uhr. 
                                                                 
                                                                 In gemütlicher Atmosphäre könnt ihr ganz entspannt eure Weihnachtswünsche entdecken und die kleinen sowie großen Unikate finden. Der Duft von Räucherkerzen, Plätzchen und Glühwein begleitet euch dabei. 
                                                                 Auf Wunsch verpacken wir eure Lieblingsstücke zu wundervollen Geschenken – perfekt zum Weitergeben an Familie und Freunde. 
                                                                 
                                                                 Kommt vorbei – wir freuen uns auf euch!
                                                                 
                                                                 - Keine Buchung nötig -`,
                                                                    price: '0,00',
                                                                    restAmount:'100',
                                                                  },
                                                                  {
                                                                    id:"1844155223116943",
                                                                    author: "Kati",
                                                                    title: 'Advent in deiner StadtWERKSTATT',
                                                                    start: new Date(2025,11, 14, 12, 0),
                                                                    end: new Date(2025, 11, 14, 18, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Advent in deiner StadtWERKSTATT' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/advent2.jpeg',
                                                                    hexColor:'#8f2d56',
                                                                    description:`
                                                                 Erstmals öffnen wir an zwei Adventssonntagen die Türen der Stadtwerkstatt: 
                                                                 Am 1. Advent und am 3. Advent, jeweils von 12 bis 18 Uhr. 
                                                                 
                                                                 In gemütlicher Atmosphäre könnt ihr ganz entspannt eure Weihnachtswünsche entdecken und die kleinen sowie großen Unikate finden. Der Duft von Räucherkerzen, Plätzchen und Glühwein begleitet euch dabei. 
                                                                 Auf Wunsch verpacken wir eure Lieblingsstücke zu wundervollen Geschenken – perfekt zum Weitergeben an Familie und Freunde. 
                                                                 
                                                                 Kommt vorbei – wir freuen uns auf euch!
                                                                 
                                                                 - Keine Buchung nötig -`,
                                                                    price: '0,00',
                                                                    restAmount:'100',
                                                                  },
                                                                  {
                                                                    id:"184415522831185",
                                                                    author: "Petra",
                                                                    title: 'Sommersonnenwende mit guten Tropfen aus Malz und Hopfen',
                                                                    start: new Date(2025, 5, 21, 18, 0),
                                                                    end: new Date(2025, 5, 21, 20, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Sommersonnenwende mit guten Tropfen aus Malz und Hopfen' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/stadt.jpeg',
                                                                    hexColor:'#FFB6C1',
                                                                    description:`
                                                                  Stadtführung auf und unter den Steinen von Bautzen mit
Hilde, dem Waschweib von der Spree
und anschließender Kraft-Bier-Verkostung.


Liebhaber des Hopfengebräus – und Genießerinnen –
nimmt Hilde mit auf eine Zeitreise durch die Historie
von Bautzen vom Dom bis zum schiefen Turm im
Zentrum der Stadt. Anschließend treffen wir
Braumeister Maik zum Bier-Tasting von ProBier Cunewalde in der StadtWerkstatt.


Unterhaltsam plaudert Hilde über das Bierbrauen heute
und im mittelalterlichen Budissin, und natürlich
entschlüpft ihr dabei auch manches Geheimnis.


Veranstaltung: 21.6.2025, ab 18:00 Uhr


Ticket: 25 Euro pP (ü18), inklusive Stadtführung mit
Hilde, Besichtigung Tonnnengewölbe unterm Rathaus und
Bier-Tasting mit ProBier aus Cunewalde.
Da die Plätze begrenzt sind, ist verbindliche
Reservierung dringend erforderlich.
                                                                    `,
                                                                    price: '25,00',
                                                                    restAmount:20,
                                                                  },

                                                                  {
                                                                    id:"1844125522831185",
                                                                    author: "Dominic",
                                                                    title: 'Info-Abend: Immobilie verkaufen – aber richtig!',
                                                                    start: new Date(2025, 6, 25, 18, 0),
                                                                    end: new Date(2025, 6, 25, 20, 0),
                                                                    allDay: false,
                                                                    resource: { id: 1, details: 'Info-Abend: Immobilie verkaufen – aber richtig!' },
                                                                    titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/infoabend.png',
                                                                    hexColor:'#FF6700',
                                                                    description:`
                                                                  Immobilie verkaufen – aber richtig!


Ein kostenfreier Informationsabend für Hauseigentümer, die den Verkauf ihrer Immobilie professionell und stressfrei gestalten möchten. In entspannter Atmosphäre erfahren Sie, wie Sie den Marktwert realistisch einschätzen, Ihre Immobilie ansprechend präsentieren, Besichtigungen effizient organisieren und den Verkaufsprozess bis zur notariellen Beurkundung erfolgreich abschließen. Verständlich erklärt, ohne Fachchinesisch – dafür mit echtem Praxiswissen, hilfreichen Tipps und Raum für Ihre Fragen.
                                                                    `,
                                                                    price: '0,00',
                                                                    restAmount:15,
                                                                  }
  /*{
  "id": "432135856",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 4, 8, 19, 0),
  "end": new Date(2025, 4, 8, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135857",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 4, 15, 19, 0),
  "end": new Date(2025, 4, 15, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135858",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 4, 22, 19, 0),
  "end": new Date(2025, 4, 22, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135859",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 4, 29, 19, 0),
  "end": new Date(2025, 4, 29, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135860",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 5, 5, 19, 0),
  "end": new Date(2025, 5, 5, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135861",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 5, 12, 19, 0),
  "end": new Date(2025, 5, 12, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135862",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 5, 19, 19, 0),
  "end": new Date(2025, 5, 19, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl":process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135863",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 5, 26, 19, 0),
  "end": new Date(2025, 5, 26, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135864",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 6, 3, 19, 0),
  "end": new Date(2025, 6, 3, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135865",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 6, 10, 19, 0),
  "end": new Date(2025, 6, 10, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135866",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 6, 17, 19, 0),
  "end": new Date(2025, 6, 17, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135867",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 6, 24, 19, 0),
  "end": new Date(2025, 6, 24, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135868",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 6, 31, 19, 0),
  "end": new Date(2025, 6, 31, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135869",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 7, 7, 19, 0),
  "end": new Date(2025, 7, 7, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135870",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 7, 14, 19, 0),
  "end": new Date(2025, 7, 14, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135871",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 7, 21, 19, 0),
  "end": new Date(2025, 7, 21, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135872",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 7, 28, 19, 0),
  "end": new Date(2025, 7, 28, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135873",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 8, 4, 19, 0),
  "end": new Date(2025, 8, 4, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135874",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 8, 11, 19, 0),
  "end": new Date(2025, 8, 11, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135875",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 8, 18, 19, 0),
  "end": new Date(2025, 8, 18, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135876",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 8, 25, 19, 0),
  "end": new Date(2025, 8, 25, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135877",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 9, 2, 19, 0),
  "end": new Date(2025, 9, 2, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135878",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 9, 9, 19, 0),
  "end": new Date(2025, 9, 9, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135879",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 9, 16, 19, 0),
  "end": new Date(2025, 9, 16, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135880",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 9, 23, 19, 0),
  "end": new Date(2025, 9, 23, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135881",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 9, 30, 19, 0),
  "end": new Date(2025, 9, 30, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135882",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 10, 6, 19, 0),
  "end": new Date(2025, 10, 6, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135883",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 10, 13, 19, 0),
  "end": new Date(2025, 10, 13, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135884",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 10, 20, 19, 0),
  "end": new Date(2025, 10, 20, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135885",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 10, 27, 19, 0),
  "end": new Date(2025, 10, 27, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135886",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 11, 4, 19, 0),
  "end": new Date(2025, 11, 4, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135887",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 11, 11, 19, 0),
  "end": new Date(2025, 11, 11, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Ihr liebt Whisky oder Rum? Dann erlebt mit euren Freunden, \n    Kollegen oder der Familie einen genussvollen Abend!\n    Bereits ab 4 Personen k\u00f6nnt ihr in der Stadtwerkstatt oder\n    bei euch zuhause unseren Experten Mario M\u00fcnzberg buchen.\n    Er nimmt euch mit auf eine geschmackliche Reise durch\n    ausgew\u00e4hlte Sorten und bringt euch mit spannenden Geschichten\n    das Besondere an jedem Tropfen n\u00e4her.\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135888",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 11, 18, 19, 0),
  "end": new Date(2025, 11, 18, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Whisky und Rum genie\u00dfen \u2013 in gem\u00fctlicher Runde mit unserem\n    Kenner Mario M\u00fcnzberg. Perfekt f\u00fcr Gruppen ab 4 Personen.\n    Verkostet besondere Tropfen und erfahrt spannende Hintergr\u00fcnde\n    aus der Welt edler Spirituosen. Ideal f\u00fcr private Feiern oder\n    entspannte Teamevents!\n    ",
  "price": "30,00",
  "restAmount": 12
},
  {
  "id": "432135889",
  "author": "Markus",
  "title": "Rum- und Whisky-Tasting",
  "start": new Date(2025, 11, 25, 19, 0),
  "end": new Date(2025, 11, 25, 21, 0),
  "allDay": false,
  "resource": {
    "id": 1,
    "details": "Rum- und Whisky-Tasting"
  },
  "titleImageUrl": process.env.REACT_APP_PUBLIC_URL + '/Workshop/tasting.png',
  "hexColor": "#000088",
  "description": "\n    Lust auf ein besonderes Tasting-Erlebnis? Unser Experte\n    Mario M\u00fcnzberg f\u00fchrt euch durch eine exklusive Auswahl\n    an Whisky- und Rum-Spezialit\u00e4ten \u2013 mit Charme, Wissen und Genuss.\n    Ein tolles Geschenk oder Gruppen-Highlight f\u00fcr Genie\u00dfer!\n    ",
  "price": "30,00",
  "restAmount": 12
}*/
        // Füge hier weitere Events hinzu
      // Füge hier weitere Events hinzu
    // Füge hier weitere Events hinzu
    ,/*{
      id:"432358551",
      author: "Steffen",
      title: '„Geht nicht - gibt’s nicht!“ - lebendiger Lese-Abend mit Steffen Nowack ',
        start: new Date(2026, 3, 4, 19, 0),
        end: new Date(2026, 3, 4, 21,0),
        allDay: false,
        resource: { id: 1, details: '„Geht nicht - gibt’s nicht!“ - lebendiger Lese-Abend mit Steffen Nowack ' },
        titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/steffenbuch2.jpeg',
        hexColor:'#6d0707',
        description:`
    Hast du Lust auf einen besonderen Abend - mit wundersamen Geschichten, lebendigem Austausch über Gott und die Welt sowie jeder Menge Spaß - in gemütlicher Runde?


Dann sei gern am Ostersamstag mit dabei, wenn Bestseller-Autor Steffen Nowack aus dem Nähkästchen plaudert und in seinem zweiten Wohnzimmer, der Stadtwerkstatt Bautzen seinen Bestseller „Geht nicht - gibt’s nicht!“ vorstellt.


Es wird garantiert kurzweilig und
du kannst ihm jederzeit Fragen stellen und so den Abend mit gestalten🤩.


Die Anmeldung ist hier mit der Zusage oder unter 0176 531 297 36 möglich.
Der Eintritt ist frei, wir freuen uns auf dich!
`,
        price: '0,00',
        restAmount:12,
      },*/
      {
        id:"48552",
        author: "Dienemann",
        title: 'Mit Hopfen nach Poetistan - Verkostung feiner Biere und Lyriklesung',
          start: new Date(2025, 9, 25, 19, 0),
          end: new Date(2025, 9, 25, 21,0),
          allDay: false,
          resource: { id: 1, details: 'Mit Hopfen nach Poetistan - Verkostung feiner Biere und Lyriklesung' },
          titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/poetistan.jpeg',
          hexColor:'#98ff98',
          description:`
      Eine Kombination der besonderen Art. Die ProBier-Werkstatt – eine Mikrobrauerei aus Cunewalde – trifft auf Dienemann – einen Dichter aus Bautzen. Sie bekommen verschiedene Biere vom Brauer persönlich zur Verkostung präsentiert und dazu die Lyrik von Dienemann vorgetragen. Kommen Sie mit auf eine Reise nach Poetistan. Bier und Lyrik aus der Region an einem exklusiven Abend.`,
          price: '35,00',
          restAmount:12,
        }
        ,{
          id:"4323583",
          author: "Dienemann",
          title: 'Mit Hopfen nach Poetistan - Verkostung feiner Biere und Lyriklesung',
            start: new Date(2025, 10, 15, 19, 0),
            end: new Date(2025, 10, 15, 21,0),
            allDay: false,
            resource: { id: 1, details: 'Mit Hopfen nach Poetistan - Verkostung feiner Biere und Lyriklesung' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/poetistan.jpeg',
            hexColor:'#98ff98',
            description:`
        Eine Kombination der besonderen Art. Die ProBier-Werkstatt – eine Mikrobrauerei aus Cunewalde – trifft auf Dienemann – einen Dichter aus Bautzen. Sie bekommen verschiedene Biere vom Brauer persönlich zur Verkostung präsentiert und dazu die Lyrik von Dienemann vorgetragen. Kommen Sie mit auf eine Reise nach Poetistan. Bier und Lyrik aus der Region an einem exklusiven Abend.`,
            price: '35,00',
            restAmount:12,
          },
          {
          id:"432358312",
          author: "LichtMetta",
          title: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ',
            start: new Date(2025, 10, 25, 17, 0),
            end: new Date(2025, 10, 25, 19,0),
            allDay: false,
            resource: { id: 1, details: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Lichtmetta/workshop.jpeg',
            hexColor:'#f5b000ff',
            description:`
        Tauche ein in die faszinierende Welt von Holz, Licht und Kreativität! In diesem Workshop baust du dein eigenes LichtMetta-Haus – ein liebevoll designtes Häuschen aus präzise lasergeschnittenem Holz, das du individuell gestalten kannst. Ob als Räucherhaus, Teelichthaus oder einfach als dekoratives Unikat – deiner Fantasie sind keine Grenzen gesetzt.


Du lernst Schritt für Schritt:
- wie die einzelnen Teile entstehen und wie der Laserschneidprozess funktioniert,
- wie du dein Haus zusammenbaust, klebst und bemalst,
- und wie du es mit persönlichen Lasergravuren oder Aufschriften einzigartig machst.


Der Workshop ist ideal für Groß und Klein, für Familien, Freundesgruppen oder als besonderes Event zum Feiern und Entspannen. Jeder geht am Ende mit einem selbst gestalteten kleinen Kunstwerk nach Hause – und mit einer Portion LichtMetta im Herzen.


🪵 Material: Lasergeschnittenes Holz (mehrteiliger Bausatz)
🎨 Technik: Basteln, Kleben, Bemalen, Lasergravur
🕯️ Geeignet für: Einzelpersonen, Familien, Gruppen & Feiern
📅 Termine: Nach Vereinbarung – gerne individuelle Events auf Anfrage`,
            price: '49,99',
            restAmount:12,
          },
          {
          id:"4323583121",
          author: "LichtMetta",
          title: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ',
            start: new Date(2025, 11, 4, 17, 0),
            end: new Date(2025, 11, 4, 19,0),
            allDay: false,
            resource: { id: 1, details: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Lichtmetta/workshop.jpeg',
            hexColor:'#f5b000ff',
            description:`
        Tauche ein in die faszinierende Welt von Holz, Licht und Kreativität! In diesem Workshop baust du dein eigenes LichtMetta-Haus – ein liebevoll designtes Häuschen aus präzise lasergeschnittenem Holz, das du individuell gestalten kannst. Ob als Räucherhaus, Teelichthaus oder einfach als dekoratives Unikat – deiner Fantasie sind keine Grenzen gesetzt.


Du lernst Schritt für Schritt:
- wie die einzelnen Teile entstehen und wie der Laserschneidprozess funktioniert,
- wie du dein Haus zusammenbaust, klebst und bemalst,
- und wie du es mit persönlichen Lasergravuren oder Aufschriften einzigartig machst.


Der Workshop ist ideal für Groß und Klein, für Familien, Freundesgruppen oder als besonderes Event zum Feiern und Entspannen. Jeder geht am Ende mit einem selbst gestalteten kleinen Kunstwerk nach Hause – und mit einer Portion LichtMetta im Herzen.


🪵 Material: Lasergeschnittenes Holz (mehrteiliger Bausatz)
🎨 Technik: Basteln, Kleben, Bemalen, Lasergravur
🕯️ Geeignet für: Einzelpersonen, Familien, Gruppen & Feiern
📅 Termine: Nach Vereinbarung – gerne individuelle Events auf Anfrage`,
            price: '49,99',
            restAmount:12,
          },
          {
          id:"4323583122",
          author: "LichtMetta",
          title: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ',
            start: new Date(2025, 11, 8, 17, 0),
            end: new Date(2025, 11, 8, 19,0),
            allDay: false,
            resource: { id: 1, details: '✨ LichtMetta – Kreatives Gestalten mit Laser & Licht - Baue dein eigenes Räucherhaus ✨ ' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Lichtmetta/workshop.jpeg',
            hexColor:'#f5b000ff',
            description:`
        Tauche ein in die faszinierende Welt von Holz, Licht und Kreativität! In diesem Workshop baust du dein eigenes LichtMetta-Haus – ein liebevoll designtes Häuschen aus präzise lasergeschnittenem Holz, das du individuell gestalten kannst. Ob als Räucherhaus, Teelichthaus oder einfach als dekoratives Unikat – deiner Fantasie sind keine Grenzen gesetzt.


Du lernst Schritt für Schritt:
- wie die einzelnen Teile entstehen und wie der Laserschneidprozess funktioniert,
- wie du dein Haus zusammenbaust, klebst und bemalst,
- und wie du es mit persönlichen Lasergravuren oder Aufschriften einzigartig machst.


Der Workshop ist ideal für Groß und Klein, für Familien, Freundesgruppen oder als besonderes Event zum Feiern und Entspannen. Jeder geht am Ende mit einem selbst gestalteten kleinen Kunstwerk nach Hause – und mit einer Portion LichtMetta im Herzen.


🪵 Material: Lasergeschnittenes Holz (mehrteiliger Bausatz)
🎨 Technik: Basteln, Kleben, Bemalen, Lasergravur
🕯️ Geeignet für: Einzelpersonen, Familien, Gruppen & Feiern
📅 Termine: Nach Vereinbarung – gerne individuelle Events auf Anfrage`,
            price: '49,99',
            restAmount:12,
          },
                {
          id:"4323583123",
          author: "LichtMetta",
          title: '✨ Bautzener Lichterglanz – Gießen & Gestalten ✨ ',
            start: '',
             end: '',
            allDay: false,
            resource: { id: 1, details: '✨ Bautzener Lichterglanz – Gießen & Gestalten ✨ ' },
            titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/lichtmettabautzen.jpeg',
            hexColor:'#f5b000ff',
            description:`
        Kreativität trifft Gemütlichkeit: Erschaffe deine eigenen Unikate für Teelichter oder Stabkerzen.
        
        In der stimmungsvollen Atmosphäre von Lichtmetta laden wir dich ein, für ein zwei Stunden den Alltag zu vergessen und in die Welt des Formens und Gestaltens einzutauchen. 
        
        Gemeinsam fertigen wir stilvolle Kerzenhalter an, die nicht nur dein Zuhause erstrahlen lassen, sondern auch ein Stück Bautzener Handwerkstradition in moderner Form widerspiegeln.
        
        Was dich erwartet:
        - Gießen mit Herz: Wir arbeiten mit hochwertigen Gussmassen, um minimalistische und edle Halter für Teelichter und klassische Stabkerzen herzustellen. Du lernst das richtige Mischverhältnis und den perfekten Guss für glatte Oberflächen.
        - Farbe & Design: Färbe die Gussmasse nach deinen Wünschen. Ob sanfte Pastelltöne, edle Goldakzente, minimalistische Muster oder eine individuelle Bemalung – du entscheidest, welchen Look deine Halter erhalten.
        - Ein handgemachtes Stück verdient eine besondere Hülle. Wir gestalten gemeinsam passende Geschenkanhänger und verpacken deine Kunstwerke so, dass sie direkt bereit zum Verschenken (oder Selbstbehalten) sind.
        
        Inhalt: Gießen von einem Halter, Material für Gestaltung & Verpackung, Geschenkanhänger
        Atmosphäre: Inkl. kleiner Erfrischungen/ Snacks und einer Prise Lichtmetta-Magie"Licht ist die Sprache der Seele. 
        



        Lass uns gemeinsam dafür sorgen, dass Bautzen ein kleines bisschen heller leuchtet."
            `,
            price: '49,99',
            restAmount:12,
          },
           {
                                    id:"18441553422339",
                                    author: "Nicole",
                                    title: 'Nähkurs für Kinder',
                                      start: new Date(2026, 9, 14, 15, 0),
                                      end: new Date(2026, 9, 14, 17,30),
                                      allDay: false,
                                      resource: { id: 1, details: 'Nähkurs für Kinder' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopnaehen.jpeg',
                                      hexColor:'#31162d',
                                      description:`
                                      
                          
                                      `,
                                      price: '25,00',
                                      restAmount:12,
                                    },
                                      {
                                    id:"1844155342s2339",
                                    author: "Axel & Kristin",
                                    title: 'Töpferkurs für Erwachsene',
                                      start: new Date(2026, 4, 9, 13, 0),
                                      end: new Date(2026, 4, 9, 15,0),
                                      allDay: false,
                                      resource: { id: 1, details: 'Töpferkurs für Erwachsene' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshoptöpferholz.png',
                                      hexColor:'#15064b',
                                      description:`
                                       Töpfere deine eigene Steinzeugschale* ganz ohne Vorkenntnisse!


Wir fertigen von Hand aus Ton kreative Schalen, die du vielseitig als Deko, in der Küche oder im Garten einsetzen kannst. 


Die Schale wird im Nachgang individuell nach deinem Wunsch von mir in der Töoferwerkstatt glasiert. 


Die 2 Brände, sowie das Glasieren sind bereits im Preis enthalten.


*Steinzeug ist nach dem Brennen wasserdicht, spülmaschinenfest und Temperaturbeständig bis 260 Grad Celsius.
                          
                                      `,
                                      price: '45,00',
                                      restAmount:12,
                                    },
                                       {
                                    id:"18441553422s2339",
                                    author: "Axel & Kristin",
                                    title: 'Töpferkurs für Erwachsene',
                                      start: new Date(2026, 5, 6, 13, 0),
                                      end: new Date(2026, 5, 5, 15,0),
                                      allDay: false,
                                      resource: { id: 1, details: 'Töpferkurs für Erwachsene' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshoptöpferholz.png',
                                      hexColor:'#15064b',
                                      description:`
                                       Töpfere deine eigene Steinzeugschale* ganz ohne Vorkenntnisse!


Wir fertigen von Hand aus Ton kreative Schalen, die du vielseitig als Deko, in der Küche oder im Garten einsetzen kannst. 


Die Schale wird im Nachgang individuell nach deinem Wunsch von mir in der Töoferwerkstatt glasiert. 


Die 2 Brände, sowie das Glasieren sind bereits im Preis enthalten.


*Steinzeug ist nach dem Brennen wasserdicht, spülmaschinenfest und Temperaturbeständig bis 260 Grad Celsius.
                          
                                      `,
                                      price: '45,00',
                                      restAmount:12,
                                    },
                                  
                                  {
                                    id:"16544155342262339",
                                    author: "Wiola",
                                    title: 'Keramik Workshop - Zauberhüte aus Ton',
                                     start: new Date(2026, 9, 17, 15, 0),
                                      end: new Date(2026, 9, 17, 17,30),
                                      allDay: false,
                                      resource: { id: 1, details: 'VKeramik Workshop - Zauberhüte aus Ton' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Workshop/workshopkeramik.jpeg',
                                      hexColor:'#373b29',
                                      description:`




                                      `,
                                      price: '40,00',
                                      restAmount:12,
                                       
                                    },
                                    {
                                    id:"165441553422632339",
                                    author: "Nico",
                                    title: 'Vortrag: "DER FILM DEINES LEBENS"',
                                     start: new Date(2026, 10, 27, 18, 30),
                                      end: new Date(2026, 10, 27, 21,30),
                                      allDay: false,
                                      resource: { id: 1, details: 'Vortrag: "DER FILM DEINES LEBENS"' },
                                      titleImageUrl: process.env.REACT_APP_PUBLIC_URL +'/Nico_Froehlich/Nico_Froehlich7.jpeg',
                                      hexColor:'#607e0e',
                                      description:`
Klappe. Und Action.
Der Vorhang fällt und er geht los. Der Film deines Lebens.





Hast du dich schon einmal mit dem Gedanken beschäftigt, was der Sinn deines Lebens ist, warum du hier bist und was deine Lebensaufgabe ist?




Wie heißt eigentlich der Film DEINES Lebens.
Welches Genre hat er und welche Darsteller kommen in ihm vor?
Worauf richtest du den Fokus deiner Kamera?
Welche Kostüme und welche Kulissen zeigen sich auf?
​Schafft es DEIN Film zur Preisverleihung und was ist DEINE Gage?




In meinem etwa zweistündigen Vortrag lade ich dich ein, dein Leben aus einer neuen Perspektive zu betrachten. Gemeinsam gehen wir Fragen nach, die oft im Alltag verloren gehen:




Wer bist du wirklich?
Worauf richtest du deinen Fokus?
Und welchen Film möchtest du leben?




​Was erwartet Dich?
- inspirierende Impulse aus dem gleichnamigen Buch
- neue Blickwinkel auf dein eigenes Leben
- ehrliche Selbstreflexion 
- Gedanken über Sinn, Bewusstsein und Lebensgestaltung
​- emotionale und humorvolle Momente
- Austausch in wertschätzender Atmosphäre
​- kleine Impulse, die lange nachwirken können




Für wen ist der Vortrag?
Für Menschen, die...


- spüren, dass da noch mehr in ihnen steckt
- sich selbst wieder näherkommen wollen
- ihr Leben bewusster gestalten möchten
- sich nach Klarheit und innerer Ruhe sehnen
- offen für neue Perspektiven sind
​- sich inspirieren lassen möchten
- sich fragen: "Welchen Film will ich leben?"






Einlass: 18:30 Uhr
Beginn: 19 Uhr




Vorverkauf/Reservierung in der StadtWerkstatt oder über www.froesi-balanceplus.com
                                      `,
                                      price: '44,00',
                                      restAmount:12,
                                       
                                    },
          
  ];
  export default events;